// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-11T19:13:53.028Z
// Property: The Avenue (ID: 6767906449167721)
// Collections: 40 amenities, 20 floorplans (live), 19 photos, 72 POIs, 5 reviews, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5760613594693632",
  "multihub_property_id": "6767906449167721",
  "property_external_id": "794bz8z",
  "property_zillow_url": "https://www.zillow.com/apartments/atlanta-ga/smith-and-porter/Ck8WQM/",
  "property_apartments_url": "https://www.apartments.com/smith-and-porter-atlanta-ga/794bz8z/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-avenue",
  "property_name": "The Avenue",
  "property_website_url": "https://multihub.responsivewebsitebuilder.io/site/257873a0/?preview=true&insitepreview=true&dm_device=desktop",
  "property_domain": null,
  "property_address": "210 Peters St SW",
  "property_full_address": "210 Peters St SW, Atlanta, GA 30313",
  "property_address_1": "210 Peters St SW",
  "property_address_2": null,
  "property_address_city": "Atlanta",
  "property_address_state": "GA",
  "property_address_zip_full": null,
  "property_address_zip": "30313",
  "property_address_country": "US",
  "property_address_county": "Fulton County",
  "property_neighborhood_address": "Downtown Atlanta",
  "property_address_latitude": "33.7487406",
  "property_address_longitude": "-84.39970149999999",
  "property_email": null,
  "property_phone": "5555555555",
  "property_call_tracking_phone": null,
  "property_company_name": "Rebel Residential",
  "property_company_url": null,
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Modern Castleberry Hill apartments with standout style.</strong> Smith &amp; Porter pairs upscale finishes, oversized windows, and airy 9- to 12-foot ceilings with everyday convenience in the heart of Atlanta. Explore our <a href=\"/amenities\">apartment features</a>, then <a href=\"/schedule-a-tour\">schedule your tour</a> today.</p>",
  "property_long_description": "<p><strong>Downtown Atlanta energy, Castleberry Hill character.</strong> At The Avenue, you’re surrounded by the brick warehouses, galleries, murals, and restaurant scene that make this historic arts district one of the city’s most distinctive places to live. From Peters Street, it’s easy to reach Mercedes-Benz Stadium, State Farm Arena, Centennial Olympic Park, No Mas! Cantina, Bottle Rocket, and MARTA connections for the rest of Atlanta.</p><p>Inside the community, choose from modern one- and two-bedroom <a href=\"/floor-plans\">floor plans</a> with high ceilings, oversized windows, wood-style living areas, granite countertops, stainless-steel appliances, full-sized washers and dryers, and spacious closets. Select layouts add a balcony, sunroom, rooftop terrace, barn door, or skyline view.</p><p>Beyond your front door, the <a href=\"/amenities\">amenity collection</a> keeps everyday living polished and convenient, with a resort-style pool, industrial pool barn pavilion, co-working office spaces, fitness club, bicycle storage, package room, fire pit area, controlled access, and an upper-level club room and terrace with city views.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a0243c-be40-7289-b301-a20deb0fd5f1.webp",
  "property_featured_image_media": {
    "alt_text": "Luxury swimming pool and lounge area at an apartment complex at sunset.",
    "public_id": "01a0243c-be40-7289-b301-a20deb0fd5f1",
    "storage_key": "property/6767906449167721/01a0243c-be40-7289-b301-a20deb0fd5f1.webp",
    "width": 1920,
    "height": 1438
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "116",
  "property_year_built": "2019",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "75.86206896551724",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "35",
  "property_pet_restrictions": "Dogs and Cats Allowed. Weight limit: 35 lb per pet. Maximum 2 pets per unit.",
  "property_pet_policy_description": "Dogs and Cats Allowed. Weight limit: 35 lb per pet. Maximum 2 pets per unit. Pet fees and monthly pet rent will apply.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a020a2-2b8e-717f-977b-af99d4a66056.webp",
  "property_primary_logo_media": {
    "alt_text": "The Avenue logo",
    "public_id": "01a020a2-2b8e-717f-977b-af99d4a66056",
    "storage_key": "property/6767906449167721/01a020a2-2b8e-717f-977b-af99d4a66056.webp",
    "width": 1092,
    "height": 416
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": null,
  "property_mono_black_logo_media": null,
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5760613594693632/01a03915-19b6-71d4-aeb8-805d7480607e.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#b28c58",
  "property_secondary_color": "#3e441d",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "673 - 1,428 sq ft",
  "property_sqft_min": "673",
  "property_sqft_max": "1,428",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 28,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJiwgy338D9YgRFavgB-xaqRI",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Avenue",
  "property_home_romance_title": "Embrace the Charm of Your New Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Urban energy, resort-style ease.</strong> The Avenue pairs a sparkling pool with an industrial pool barn pavilion, amenity deck, fire pit area, and upper-level club room with city views. Co-working spaces, package room convenience, online resident tools, and key-drop charging stations keep daily details streamlined, while apartment finishes like oversized windows, 9- to 12-foot ceilings, granite countertops, stainless-steel appliances, and full-sized washer and dryer sets bring polished function home.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with Downtown Atlanta character.</strong> Choose from one- and two-bedroom layouts at The Avenue, including loft, corner, balcony, and terrace-level options. Open living areas, well-equipped kitchens, oversized windows, and high ceilings keep each home bright and functional, while granite countertops, stainless-steel appliances, wood-style flooring, and full-sized washer and dryer sets add everyday polish.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture loft-inspired living in Downtown Atlanta.</strong> Preview bright kitchens with crisp cabinetry, contrasting tile, oversized windows, high ceilings, wood-style flooring, and walk-in closet space. Then step into standout community scenes: a resort-style pool, fire pit, skyline views, and polished co-working spaces. Browse the full gallery to see The Avenue from every angle.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Castleberry Hill starts just outside.</strong> Step from The Avenue into Downtown Atlanta’s creative side, where brick warehouses, murals, galleries, and Peters Street energy set the scene. Second Friday Art Stroll stops, converted-warehouse dining, cocktails, Mercedes-Benz Stadium, MARTA access, and the downtown grid keep more of Atlanta within easy reach.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents are talking about the difference attentive service makes.</strong> Reviews for The Avenue highlight responsive leasing, skilled maintenance, and Lamar’s hands-on management—credited with a cleaner, more cared-for community. Add in appreciated amenities, everyday perks, and a convenient Downtown Atlanta location, and it’s easy to see why one resident summed it up as “10 out of 10.” Read more to hear it in their own words.</p>",
  "property_neighborhood_blurb": "<p><strong>Your neighborhood starts with a stroll.</strong> From The Avenue, Downtown Atlanta opens into Castleberry Hill’s creative blocks, where brick warehouses, murals, and gallery doors give everyday errands a more artful backdrop. Follow Peters and Walker streets for Second Friday Art Stroll stops like Besharat Gallery, Peters Street Station, and Atlantucky, then keep the evening close with converted-warehouse dining, cocktails, and game-day energy near Mercedes-Benz Stadium. When you want a wider Atlanta connection, nearby MARTA access and the downtown street grid make it simple to reach offices, campuses, venues, and parks across the city. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how The Avenue puts the neighborhood at your pace.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity-rich living with an urban edge.</strong> At The Avenue, your routine gets a polished backdrop—from a sparkling resort-style pool and industrial pool barn pavilion to an amenity deck, fire pit area, and upper-level club room with city views. Workdays feel easier with co-working office spaces, package room convenience, online resident tools, key-drop charging stations, and flexible rent payment options.</p><p>Inside, oversized windows, 9- to 12-foot ceilings, wood-style flooring, granite countertops, stainless-steel appliances, and full-sized washer and dryer sets bring everyday function into focus. Select homes add barn doors, skyline views, or a balcony, sunroom, or rooftop terrace. Browse the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make your move?</strong> Start your online application for an Atlanta apartment with upscale interiors, open layouts, oversized windows, and everyday conveniences like stainless-steel appliances and full-sized washers and dryers—all in the heart of historic Castleberry Hill.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact the leasing team at Smith &amp; Porter Apartments for help planning your visit, exploring modern apartment living in Castleberry Hill, or scheduling a tour. We’d love to show you around.<br>Se habla Español.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Smith &amp; Porter?</strong> Start here for quick answers about the community, leasing, amenities, and everyday living in Castleberry Hill. If you need more details or are ready to see it in person, our leasing team is happy to help schedule your tour. Se habla Español.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your day-to-day.</strong> The Avenue gives you a focused collection of one- and two-bedroom floor plans in Downtown Atlanta, from streamlined one-bedroom homes to loft, corner, balcony, and terrace-level options with extra character. Compare open living areas, well-equipped kitchens, closet space, and outdoor or view-focused selections as you browse current pricing and availability.</p><p>Inside, modern finishes make each plan feel polished and practical: granite countertops, stainless-steel appliances, wood-style flooring in main living areas, full-sized washer and dryer sets, oversized windows, and high ceilings that help your space feel bright and open. Explore finishes on the <a href=\"/amenities\">amenities page</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite floor plan in person.</p>",
  "property_gallery_blurb": "<p><strong>See The Avenue from every angle.</strong> Browse photos that bring the details into focus: bright kitchens with crisp cabinetry and contrasting tile, open living areas framed by oversized windows, and high ceilings that give each home a loft-inspired feel. As you move through the gallery, look for polished finishes, wood-style flooring, walk-in closet space, and select outdoor retreats that add another layer to daily living.</p><p>Beyond your front door, the images shift to the community’s most memorable scenes—sunlit water at the <a href=\"/amenities\">resort-style pool</a>, relaxed moments around the fire pit, skyline views from upper-level spaces, and co-working areas designed with style and purpose. Like what you see? Explore <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience The Avenue in Downtown Atlanta in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore the map.</strong> See available apartments at Smith &amp; Porter and get a feel for historic Castleberry Hill, with urban convenience close at hand. Use the interactive map to browse <a href=\"/floor-plans\">floor plans</a>, compare locations, and start planning your visit.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, naps, and downtown strolls.</strong> At The Avenue, approved cats and dogs can settle into a home designed for easy everyday routines: elevator access for quick outings, controlled-access entries, full-sized washer and dryer sets for leash-day cleanups, and wood-style living areas that keep daily life polished.</p><p>Choose a layout that gives your pet a comfortable place to curl up, from bright oversized windows to select balconies, sunrooms, or rooftop terraces. When it’s time to get moving, your Downtown Atlanta address keeps leash walks close to home, with official off-leash dog parks and neighborhood pet services within an easy ride. Review the pet policy details on this page, then explore <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how pet-friendly living fits your routine.</p>",
  "property_referafriend_blurb": "<p><strong>Share the lifestyle you love.</strong> Invite friends to discover modern apartments with upscale interiors, oversized windows, and the urban convenience of historic Castleberry Hill. Send a referral today and help them find their place in the heart of Atlanta.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Smith &amp; Porter Apartments</strong><br>Modern Atlanta living comes with everyday convenience. Log in to pay rent, submit maintenance requests, and manage your account—all in one simple place.</p>",
  "property_reviews_blurb": "<p><strong>See why residents recommend The Avenue.</strong> Reviews point to a community where attentive service makes a difference—from a responsive leasing experience to maintenance requests handled by a team residents call “good at what they do.”</p><p>Residents especially highlight Lamar’s hands-on management, noting a “noticeable and positive transformation” and a property that feels clean, cared for, and well maintained. You’ll also see praise for the office staff, community amenities and perks, and the convenience of living near Downtown Atlanta. As one resident put it: “10 out of 10.” Browse the reviews below to hear more in residents’ own words.</p>",
  "property_created_at": "1787253153917",
  "property_scheduletour_blurb": "<p><strong>See Smith &amp; Porter in person.</strong> Tour upscale interiors with granite countertops, stainless-steel appliances, full-sized washers and dryers, soaring ceilings, oversized windows, and select private outdoor spaces. Schedule your tour today—we’d love to show you around.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong> Our leasing team will be in touch soon to help with next steps and tour options. In the meantime, picture modern Castleberry Hill living with upscale interiors, oversized windows, and the urban convenience that makes this Atlanta community feel like home.</p>",
  "property_virtualtours_blurb": "<p><strong>Preview the path from front door to skyline.</strong> The Avenue’s virtual tours let you move through the spaces that matter before you visit in person. Explore one-bedroom apartment layouts, a loft-style home with dramatic vertical space, and a two-bedroom residence with open living areas, modern kitchens, oversized windows, and clean contemporary finishes.</p><p>Then keep touring the community: check out the Fitness Center, Rooftop Clubhouse, Locomotive Lounge, Sky Lounge, and the broader community tour to get a feel for how each amenity connects to daily life in Downtown Atlanta. When a layout or lounge catches your eye, compare current <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see The Avenue up close.</p>",
  "property_copyright": "2026 All Rights Reserved. The Avenue",
  "property_seo_title_home": "The Avenue |  Apartments in Atlanta, GA",
  "property_seo_description_home": "Experience modern living at The Avenue in Atlanta, GA. Enjoy spacious layouts, resort-style amenities, and skyline views. Your vibrant new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Atlanta, GA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at The Avenue in Atlanta, GA. Choose from stylish one and two-bedroom floor plans designed for comfort and convenience. Browse now!",
  "property_seo_title_amenities": "Amenities | Atlanta, GA Apartments for Rent",
  "property_seo_description_amenities": "Experience life at The Avenue in Atlanta—enjoy modern amenities, a resort-style pool, fitness club, and skyline views from your new home!",
  "property_seo_title_gallery": "Gallery | Apartments in Atlanta, GA",
  "property_seo_description_gallery": "Imagine life at The Avenue in Atlanta, GA: stylish one- and two-bedroom apartments with stunning views, resort-style amenities, and a vibrant community.",
  "property_seo_title_virtualtours": "Virtual Tours | The Avenue Apartments",
  "property_seo_description_virtualtours": "Step inside The Avenue in Atlanta, GA. Take a virtual tour of our stylish one and two-bedroom apartments—your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | The Avenue Apartments",
  "property_seo_description_interactivemap": "Find your perfect spot at The Avenue in Atlanta! Use our interactive map to browse stunning one and two-bedroom apartments with resort-style amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Atlanta, GA",
  "property_seo_description_neighborhood": "Uncover Atlanta’s vibrant heartbeat at The Avenue. From cozy cafés to lush parks, discover local gems that'll make your new home truly special.",
  "property_seo_title_contact": "Contact Us | The Avenue",
  "property_seo_description_contact": "Connect with The Avenue in Atlanta! Inquire about our one and two-bedroom floor plans and let our leasing team help you find your perfect home today.",
  "property_seo_title_faqs": "FAQs | Apartments in Atlanta, GA",
  "property_seo_description_faqs": "Get answers to all your questions about The Avenue in Atlanta, GA! From floor plans to amenities, learn why our community is the perfect home for you.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Atlanta, GA",
  "property_seo_description_reviews": "Discover life at The Avenue, Atlanta! Spacious layouts, upscale amenities, and a vibrant community await. See why residents love living here!",
  "property_seo_title_applynow": "Apply Now | Apartments in Atlanta, GA",
  "property_seo_description_applynow": "Find your ideal sanctuary at The Avenue in Atlanta! Enjoy spacious floor plans, upscale amenities, and skyline views. Your new home awaits—lease online now!",
  "property_seo_title_residentaccess": "Resident Access | The Avenue",
  "property_seo_description_residentaccess": "Unlock effortless living at The Avenue! Log in to your resident portal for rent payments, maintenance requests, and community updates in vibrant Atlanta, GA.",
  "property_seo_title_referafriend": "Refer A Friend | The Avenue",
  "property_seo_description_referafriend": "Refer a friend to The Avenue in Atlanta, GA! Great friends make great neighbors—share the joy of vibrant living in our welcoming community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Avenue",
  "property_seo_description_scheduletour": "Experience modern living at The Avenue in Atlanta. Schedule your personal tour today and envision your new lifestyle in our vibrant community.",
  "property_seo_title_privacy": "Privacy Policy | The Avenue",
  "property_seo_description_privacy": "Your privacy matters at The Avenue, Atlanta. Discover our commitment to data protection and a secure living experience. View our policy now!",
  "property_seo_title_accessibility": "Website Accessibility | The Avenue",
  "property_seo_description_accessibility": "At The Avenue in Atlanta, we prioritize accessibility for all. Experience unparalleled digital inclusion tailored to enhance your living experience.",
  "property_seo_title_sitemap": "Sitemap | The Avenue",
  "property_seo_description_sitemap": "Navigate your way through The Avenue in Atlanta, GA! Find your ideal home with our detailed sitemap featuring amenities, layouts, and more.",
  "property_seo_title_thankyou": "Thank You | The Avenue",
  "property_seo_description_thankyou": "Thank you for reaching out to The Avenue in Atlanta! Our team will connect with you soon to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Atlanta, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787597689034",
  "amenities": [
    {
      "id": "ec_bc635bf7f3cf0244205ac5c6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Controlled Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d007b1597842e9191ceb8ef8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aab7a60fac8bdb4f86f201e1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fdff3de010dffa6362d52ff6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Bicycle Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_93bd5c77f6e3aa74326d99da",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Amenity Deck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c44fd03ed46d44f3b161350",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Barn Doors*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be6b2b061dae3607ba935c50",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Bicycle Storage Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_31560ca84eaa4763f12d3790",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Ceiling Fans in Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2a17e4f406d92cf9c3b0acff",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Co-Working Office Spaces",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_198700d51dcddb54587d5106",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Elevators",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5c8e5e3c4bd1b4db57a74086",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Fire Pit Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_122b44eadb02eadebcd75159",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Flexible Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4faea1e602ec06dcb48547cb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Full-Sized Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab87c25ac853ca7ecc3ac82f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Gated Community with Controlled Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ed1011b9642586d947e8f00",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Granite Countertops in Kitchens & Baths",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0cb998d5cd7ea3ce5d91e6fc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "High 9 to 12-Foot Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_af7b3166798a8bb83f070e0d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Industrial Pool Barn Pavilion",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2a6490f791db3d6fc9848cf1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Key-Drop Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a1af8880eaf0006b687a733",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Monthly Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e825e52dd5672fa687b9b505",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Non-Smoking Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6ee908687a6d8dbddd5f16b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Online Resident Portals",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cf272e482e462d851cc90bf7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Oversized Windows",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fd7bf73e1dfa2226137e9fbe",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Package Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_094f74e20deea8aee289a6ac",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Private Balconies, Sunrooms, or Rooftop Terraces*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d201095cb4ce6bb4a871af91",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Se habla Español",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51f90b89bd26504fe0b8d03f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Skyline Views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c5f90145345eaede36ae278",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Spacious Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1db4ae66e0e106b74c368f86",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Sparkling Resort-Style Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff45264183d1df7477413b94",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless-Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ede56a14bb4493d7d8547975",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "State-of-the-Art Fitness Club",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_692c6dbf09ddf3526f87ba3a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Updater",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_adea048f7a5c4313326256d6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Upper-Level Club Room & Terrace with City Views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b5d570689973027e94aca18",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Wood-Style Flooring in Kitchen & Living Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7a7c9c793160130b811501fc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_282827b3c59514f8440d229c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df45c08c907f692141e10543",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0625aedb0cad33ba6b96376d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_79a70e267e05229f5a57b4f7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Office",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc07c8a4247a1c01462cc392",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f27e88e576239b751478b3c5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "apartments",
      "external_id": "false",
      "title": "Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_6b39d808-97f4-4567-8fc1-f062460664ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02437-5d1d-7632-9ded-71ab5fb95a82.webp",
      "image_media": {
        "alt_text": "Stylish communal kitchen area with bar seating and unique rope chandelier.",
        "public_id": "01a02437-5d1d-7632-9ded-71ab5fb95a82",
        "storage_key": "property/6767906449167721/01a02437-5d1d-7632-9ded-71ab5fb95a82.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy the communal kitchen, perfect for entertaining or casual gatherings, featuring modern appliances and comfortable bar seating.",
      "link": "",
      "alt_text": "Stylish communal kitchen area with bar seating and unique rope chandelier.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2449ac99-8a9f-40ac-897d-907b066f3f8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02437-5d60-73a4-b292-2421a1326352.webp",
      "image_media": {
        "alt_text": "A communal dining area with a large wooden table and chairs, a kitchenette with a microwave and sink, and large windows overlooking palm trees.",
        "public_id": "01a02437-5d60-73a4-b292-2421a1326352",
        "storage_key": "property/6767906449167721/01a02437-5d60-73a4-b292-2421a1326352.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Gather with neighbors and friends in our beautifully appointed communal dining area, complete with a full kitchenette and comfortable seating for all.",
      "link": "",
      "alt_text": "A communal dining area with a large wooden table and chairs, a kitchenette with a microwave and sink, and large windows overlooking palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c29d721-51f0-4a86-8db1-d37bb88dd193",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02437-5873-762f-b311-12d25a3950ef.webp",
      "image_media": {
        "alt_text": "Bar area with stools and unique rope lighting.",
        "public_id": "01a02437-5873-762f-b311-12d25a3950ef",
        "storage_key": "property/6767906449167721/01a02437-5873-762f-b311-12d25a3950ef.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Gather around the stylish bar area, perfect for socializing, with unique rope lighting and ample seating. This space enhances community living.",
      "link": "",
      "alt_text": "Bar area with stools and unique rope lighting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2e57bc57-b7a5-4a64-9da3-ceb3fad91c6e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02437-53a6-720d-83d6-e88a501be98f.webp",
      "image_media": {
        "alt_text": "Modern lobby seating area with four black hanging egg chairs and a textured accent wall.",
        "public_id": "01a02437-53a6-720d-83d6-e88a501be98f",
        "storage_key": "property/6767906449167721/01a02437-53a6-720d-83d6-e88a501be98f.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lobby, featuring comfortable hanging chairs and a chic accent wall perfect for socializing or quiet contemplation.",
      "link": "",
      "alt_text": "Modern lobby seating area with four black hanging egg chairs and a textured accent wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6bf066a5-3a6f-437d-920f-6062be909833",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02437-5420-73cd-a944-d196ece2e7f8.webp",
      "image_media": {
        "alt_text": "Market pantry with refrigerators, shelves of snacks, and a self-checkout station.",
        "public_id": "01a02437-5420-73cd-a944-d196ece2e7f8",
        "storage_key": "property/6767906449167721/01a02437-5420-73cd-a944-d196ece2e7f8.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Convenient market pantry offering snacks, drinks, and essentials for residents, with a self-checkout system.",
      "link": "",
      "alt_text": "Market pantry with refrigerators, shelves of snacks, and a self-checkout station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_923fde83-6d4d-408f-858c-40773cc394ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02437-449b-7732-8093-3aa3fba5107f.webp",
      "image_media": {
        "alt_text": "Modern apartment community lounge with rustic wood accent wall and three large screens.",
        "public_id": "01a02437-449b-7732-8093-3aa3fba5107f",
        "storage_key": "property/6767906449167721/01a02437-449b-7732-8093-3aa3fba5107f.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring a striking rustic wood accent wall and multiple screens for your entertainment.",
      "link": "",
      "alt_text": "Modern apartment community lounge with rustic wood accent wall and three large screens.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_937cd8f9-84fd-4c1d-bbad-80b2e69d1a50",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02437-403e-777b-8b48-3ccce5e96fb0.webp",
      "image_media": {
        "alt_text": "Outdoor fire pit with Adirondack chairs and a pergola in a multifamily courtyard.",
        "public_id": "01a02437-403e-777b-8b48-3ccce5e96fb0",
        "storage_key": "property/6767906449167721/01a02437-403e-777b-8b48-3ccce5e96fb0.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy cozy evenings around the fire pit in our beautiful courtyard, complete with comfortable seating and a shaded pergola.",
      "link": "",
      "alt_text": "Outdoor fire pit with Adirondack chairs and a pergola in a multifamily courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_085e783e-dff7-459e-bcd2-1e2f6b7a2264",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02437-40ab-7781-9657-3a9bdbf34c99.webp",
      "image_media": {
        "alt_text": "Community lounge area with a large wooden table and bar stools, featuring a kitchenette and view of outdoor seating.",
        "public_id": "01a02437-40ab-7781-9657-3a9bdbf34c99",
        "storage_key": "property/6767906449167721/01a02437-40ab-7781-9657-3a9bdbf34c99.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Relax and socialize in the community lounge, complete with a kitchenette and comfortable seating, offering a perfect space to unwind or entertain.",
      "link": "",
      "alt_text": "Community lounge area with a large wooden table and bar stools, featuring a kitchenette and view of outdoor seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_75fec1bb-c872-4ecd-86e2-b20283b6c2a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02437-410d-71f4-9808-490821900ac1.webp",
      "image_media": {
        "alt_text": "Lobby with pool table, fireplace, seating area, and view of pool and courtyard.",
        "public_id": "01a02437-410d-71f4-9808-490821900ac1",
        "storage_key": "property/6767906449167721/01a02437-410d-71f4-9808-490821900ac1.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy community amenities like this stylish lobby, complete with a pool table, cozy seating, and a view of the resort-style pool.",
      "link": "",
      "alt_text": "Lobby with pool table, fireplace, seating area, and view of pool and courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d0c40772-5163-4320-abbd-404702af74bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02437-2878-717b-8c67-9210a74c21a9.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and surrounding lounge area with apartment buildings.",
        "public_id": "01a02437-2878-717b-8c67-9210a74c21a9",
        "storage_key": "property/6767906449167721/01a02437-2878-717b-8c67-9210a74c21a9.webp",
        "width": 1920,
        "height": 1438
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning resort-style pool, perfect for relaxation and soaking up the sun. Surrounded by comfortable lounge chairs and lush landscaping, it's the ideal spot to unwind.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and surrounding lounge area with apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d6f4a9c5-0bc3-483b-a7ce-a768e98d5f48",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02437-29b7-7200-b79f-52735e6b94c3.webp",
      "image_media": {
        "alt_text": "Treadmills and elliptical machines in a modern fitness center with a pool visible through the windows.",
        "public_id": "01a02437-29b7-7200-b79f-52735e6b94c3",
        "storage_key": "property/6767906449167721/01a02437-29b7-7200-b79f-52735e6b94c3.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with treadmills, ellipticals, and a variety of other exercise machines. Enjoy a refreshing swim in the adjacent pool after your workout.",
      "link": "",
      "alt_text": "Treadmills and elliptical machines in a modern fitness center with a pool visible through the windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bb5aacb4-1c2b-4b53-ac3a-03d77ffd3af6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02437-29a4-74c4-9561-33e5b84f3616.webp",
      "image_media": {
        "alt_text": "Industrial loft living room with exposed brick, high ceilings, and open-concept kitchen.",
        "public_id": "01a02437-29a4-74c4-9561-33e5b84f3616",
        "storage_key": "property/6767906449167721/01a02437-29a4-74c4-9561-33e5b84f3616.webp",
        "width": 1728,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Experience urban living in this stunning loft featuring exposed brick walls, soaring ceilings, and a modern open-concept kitchen perfect for entertaining.",
      "link": "",
      "alt_text": "Industrial loft living room with exposed brick, high ceilings, and open-concept kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_79f6f688-e36d-4850-abc4-49f24fa71097",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02437-2938-731d-ac7c-e7b1fab2fe08.webp",
      "image_media": {
        "alt_text": "Modern living room with white sofa, large TV, and decorative accents.",
        "public_id": "01a02437-2938-731d-ac7c-e7b1fab2fe08",
        "storage_key": "property/6767906449167721/01a02437-2938-731d-ac7c-e7b1fab2fe08.webp",
        "width": 1920,
        "height": 1271
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a comfortable white sofa, a wall-mounted television, and elegant decor, perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Modern living room with white sofa, large TV, and decorative accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c67ad8a3-9314-4767-891f-b6840ecdc57f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02437-28e1-752f-8255-8ef931734909.webp",
      "image_media": {
        "alt_text": "Gym with free weights, weight machines, and a television displaying a beach scene.",
        "public_id": "01a02437-28e1-752f-8255-8ef931734909",
        "storage_key": "property/6767906449167721/01a02437-28e1-752f-8255-8ef931734909.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with everything you need for a great workout, including free weights and cardio machines. Relax and unwind after your workout by watching your favorite show on the mounted TV.",
      "link": "",
      "alt_text": "Gym with free weights, weight machines, and a television displaying a beach scene.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1e13f6c3-18af-4d0b-ae81-7e862166bdbc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02437-243a-77d7-87ba-3b25083438bc.webp",
      "image_media": {
        "alt_text": "Kitchen area with island, coffee bar, and chairs, with doors opening to an outdoor pool area.",
        "public_id": "01a02437-243a-77d7-87ba-3b25083438bc",
        "storage_key": "property/6767906449167721/01a02437-243a-77d7-87ba-3b25083438bc.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and refreshments in our modern resident lounge, featuring a full-service coffee bar and ample seating. Step outside to relax by the sparkling pool.",
      "link": "",
      "alt_text": "Kitchen area with island, coffee bar, and chairs, with doors opening to an outdoor pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0d0df28d-557f-4cb2-8e0f-1cbe0b83576f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02437-23c6-724b-a760-33b9ef2c8a5f.webp",
      "image_media": {
        "alt_text": "Aerial view of tennis courts and apartment buildings with palm trees.",
        "public_id": "01a02437-23c6-724b-a760-33b9ef2c8a5f",
        "storage_key": "property/6767906449167721/01a02437-23c6-724b-a760-33b9ef2c8a5f.webp",
        "width": 1920,
        "height": 1438
      },
      "title": "Community",
      "description": "Enjoy a friendly match on our pristine tennis courts, set against the backdrop of our beautiful community and lush landscaping.",
      "link": "",
      "alt_text": "Aerial view of tennis courts and apartment buildings with palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_92f164ed-8170-43da-b9a1-99133d6f7729",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02437-22fe-7549-a5b0-00ea8a7f13d5.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with comfortable seating and decorative elements.",
        "public_id": "01a02437-22fe-7549-a5b0-00ea8a7f13d5",
        "storage_key": "property/6767906449167721/01a02437-22fe-7549-a5b0-00ea8a7f13d5.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed lounge area, featuring plush seating and a chic, modern design.",
      "link": "",
      "alt_text": "Stylish lounge area with comfortable seating and decorative elements.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_586b8ec8-f071-42f3-8f7e-544615c9644b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02437-2299-751b-9bb3-90a79bfe8423.webp",
      "image_media": {
        "alt_text": "Modern bedroom with metal bed frame, blue accent wall, and large windows.",
        "public_id": "01a02437-2299-751b-9bb3-90a79bfe8423",
        "storage_key": "property/6767906449167721/01a02437-2299-751b-9bb3-90a79bfe8423.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a chic metal bed frame, a striking blue accent wall, and ample natural light from large windows.",
      "link": "",
      "alt_text": "Modern bedroom with metal bed frame, blue accent wall, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6c3940f6-c015-45a4-87c8-f52e31ae5542",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02437-2290-742e-bbf2-3f5229edf67e.webp",
      "image_media": {
        "alt_text": "Rows of mailboxes in a building hallway.",
        "public_id": "01a02437-2290-742e-bbf2-3f5229edf67e",
        "storage_key": "property/6767906449167721/01a02437-2290-742e-bbf2-3f5229edf67e.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Secure mailboxes are conveniently located in a well-lit hallway, offering residents easy access to their mail.",
      "link": "",
      "alt_text": "Rows of mailboxes in a building hallway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_558511c488e290d21444fb93",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Esco Restaurant & Tapas",
      "poi_type": "Restaurants",
      "poi_address": "327 Peters St SW, Atlanta, GA 30313, USA",
      "poi_short_description": "Cool locale with a swanky vibe for American comfort food, tapas & clever cocktails, plus hookah.",
      "poi_long_description": "Cool locale with a swanky vibe for American comfort food, tapas & clever cocktails, plus hookah.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-7011-733e-9bf0-31047c9cfe2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-7011-733e-9bf0-31047c9cfe2a",
        "storage_key": "property/6767906449167721/01a02099-7011-733e-9bf0-31047c9cfe2a.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://www.escobaratlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14548951634117212819&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "esco-restaurant--tapas",
      "poi_latitude": "33.7458628",
      "poi_longitude": "-84.403832",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-941-7907",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f429db354b49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f429db354b49",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f429db354b49.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmw-1-nAD9YgRkzrldW1C6Mk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_abea16e5d96c6b44b219d8f4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "The Spinning Pie",
      "poi_type": "Restaurants",
      "poi_address": "259 Peters St SW, Atlanta, GA 30313, USA",
      "poi_short_description": "Modern, wood-trimmed hangout serving specialty pizzas, pastas & drinks from a full bar.",
      "poi_long_description": "Modern, wood-trimmed hangout serving specialty pizzas, pastas & drinks from a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-7598-7039-bcaf-13da9803825a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-7598-7039-bcaf-13da9803825a",
        "storage_key": "property/6767906449167721/01a02099-7598-7039-bcaf-13da9803825a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=827626796501297957&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-spinning-pie",
      "poi_latitude": "33.747587",
      "poi_longitude": "-84.4018",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 404-880-0703",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f429db354b49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f429db354b49",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f429db354b49.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVY8NrHAD9YgRJesNvC9SfAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_a63e94f748f1a6b89c26c663",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Frost Bistro",
      "poi_type": "Restaurants",
      "poi_address": "281 Peters St SW, Atlanta, GA 30313, USA",
      "poi_short_description": "Bistro serving American food, with brick walls, wood floors & booth, lounge, bar & patio seating.",
      "poi_long_description": "Bistro serving American food, with brick walls, wood floors & booth, lounge, bar & patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-770b-770b-ba5e-da564ea975f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-770b-770b-ba5e-da564ea975f0",
        "storage_key": "property/6767906449167721/01a02099-770b-770b-ba5e-da564ea975f0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.frostbistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8150643791615563191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frost-bistro",
      "poi_latitude": "33.7470538",
      "poi_longitude": "-84.40252430000001",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-963-5495",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f429db354b49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f429db354b49",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f429db354b49.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG2EIvHAD9YgRtxX9MVjnHHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_a362d2832adb49d400b8a4b8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "255 Tapas Lounge",
      "poi_type": "Restaurants",
      "poi_address": "255 Peters St SW, Atlanta, GA 30313, USA",
      "poi_short_description": "Lounge & patio with VIP cabanas for cocktails & New American dishes like sliders & Asian rice bowls.",
      "poi_long_description": "Lounge & patio with VIP cabanas for cocktails & New American dishes like sliders & Asian rice bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-7007-760b-8bad-26627f1ce6b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-7007-760b-8bad-26627f1ce6b0",
        "storage_key": "property/6767906449167721/01a02099-7007-760b-8bad-26627f1ce6b0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.255tapaslounge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3855246166901767558&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "255-tapas-lounge",
      "poi_latitude": "33.7477461",
      "poi_longitude": "-84.40176269999999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 404-522-2612",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-cc8e-732e-bfec-b74ce6165f2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02099-cc8e-732e-bfec-b74ce6165f2a",
        "storage_key": "property/6767906449167721/01a02099-cc8e-732e-bfec-b74ce6165f2a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX_5bq3AD9YgRhr3de_aVgDU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "lounge_bar"
    },
    {
      "id": "ec_ef25d40d5aab5ff2907552b6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "The Projects Restaurant and Lounge",
      "poi_type": "Restaurants",
      "poi_address": "264 Peters St SW, Atlanta, GA 30313, USA",
      "poi_short_description": "American comfort food and a wide selection of beers are served at this easygoing restaurant and hookah bar.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-70e2-76ae-b9c4-5738d6c53b93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-70e2-76ae-b9c4-5738d6c53b93",
        "storage_key": "property/6767906449167721/01a02099-70e2-76ae-b9c4-5738d6c53b93.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://theprojectsatlrestaurantlounge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3431920955437397529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-projects-restaurant-and-lounge",
      "poi_latitude": "33.7472768",
      "poi_longitude": "-84.40147089999999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 404-600-4013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-cc8e-732e-bfec-b74ce6165f2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02099-cc8e-732e-bfec-b74ce6165f2a",
        "storage_key": "property/6767906449167721/01a02099-cc8e-732e-bfec-b74ce6165f2a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDQ_wrk4D9YgRGbYQBu2hoC8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "ec_07d5b8c0924ec5f89b728bde",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Paschal's Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "180 Northside Dr SW, Atlanta, GA 30313, USA",
      "poi_short_description": "The signature fried chicken stars at this popular, brick-walled spot for Southern specialties.",
      "poi_long_description": "The signature fried chicken stars at this popular, brick-walled spot for Southern specialties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-70e9-753a-9af6-ec0bc07ff269.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-70e9-753a-9af6-ec0bc07ff269",
        "storage_key": "property/6767906449167721/01a02099-70e9-753a-9af6-ec0bc07ff269.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.paschalsatlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5657267454724616444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paschals-restaurant--bar",
      "poi_latitude": "33.7494312",
      "poi_longitude": "-84.4037907",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-835-0833",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f429db354b49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f429db354b49",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f429db354b49.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_wmtiXoD9YgR_DA9zsamgk4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "soul_food_restaurant"
    },
    {
      "id": "ec_863bbab0f6802c23bdb022f7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Match Bar& Oven",
      "poi_type": "Restaurants",
      "poi_address": "199 Walker St SW, Atlanta, GA 30313, USA",
      "poi_short_description": "Fruity tiki drinks & Polynesian bar bites offered in lively digs with a rooftop lounge.",
      "poi_long_description": "Fruity tiki drinks & Polynesian bar bites offered in lively digs with a rooftop lounge.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-764a-724e-98ed-252b919bf54a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-764a-724e-98ed-252b919bf54a",
        "storage_key": "property/6767906449167721/01a02099-764a-724e-98ed-252b919bf54a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.matchloungeatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16206310698882988440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "match-bar-oven",
      "poi_latitude": "33.7494808",
      "poi_longitude": "-84.4018573",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f429db354b49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f429db354b49",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f429db354b49.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJTi5IXoD9YgRmHmIRrdh6OA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_c5d2c8a1e8a6ecee82be1dca",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "No Mas! Cantina",
      "poi_type": "Restaurants",
      "poi_address": "180 Walker St SW Ste b, Atlanta, GA 30313, USA",
      "poi_short_description": "Mexican food & margaritas are accompanied by  vibrant decor & gift shop stocked with handmade goods.",
      "poi_long_description": "Mexican food & margaritas are accompanied by  vibrant decor & gift shop stocked with handmade goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-6d13-773b-bf62-2373b28387c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-6d13-773b-bf62-2373b28387c7",
        "storage_key": "property/6767906449167721/01a02099-6d13-773b-bf62-2373b28387c7.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.nomascantina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5077407736402218949&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "no-mas-cantina",
      "poi_latitude": "33.7498583",
      "poi_longitude": "-84.4008817",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-574-5678",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f429db354b49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f429db354b49",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f429db354b49.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTwgOhXkD9YgRxQ8TXG-TdkY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_849e6d86dbbb9d65775617b4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "ADios Cafe",
      "poi_type": "Restaurants",
      "poi_address": "180 Walker St SW Ste d, Atlanta, GA 30313, USA",
      "poi_short_description": "Mexican breakfasts, desserts & coffees are served at this colorful hub with a tropical-themed patio.",
      "poi_long_description": "Mexican breakfasts, desserts & coffees are served at this colorful hub with a tropical-themed patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-7710-734e-b493-41935698ba0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-7710-734e-b493-41935698ba0b",
        "storage_key": "property/6767906449167721/01a02099-7710-734e-b493-41935698ba0b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://adioscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17813260556975845134&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adios-cafe",
      "poi_latitude": "33.7499953",
      "poi_longitude": "-84.40099000000001",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-574-5679",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f429db354b49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f429db354b49",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f429db354b49.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJU9AJj3kD9YgRDq8FDhlqNfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_e0a6486fe43debc9d817cbe8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Bottle Rocket Fine Food and Beverage",
      "poi_type": "Restaurants",
      "poi_address": "231 Mitchell St SW, Atlanta, GA 30303, USA",
      "poi_short_description": "Trendy hangout offering sushi & Japanese-American–fusion dishes, plus creative cocktails.",
      "poi_long_description": "Trendy hangout offering sushi & Japanese-American–fusion dishes, plus creative cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-8db4-73b9-a2b2-c4de4d3b59ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-8db4-73b9-a2b2-c4de4d3b59ee",
        "storage_key": "property/6767906449167721/01a02099-8db4-73b9-a2b2-c4de4d3b59ee.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.bottlerocketatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12749357370960219843&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bottle-rocket-fine-food-and-beverage",
      "poi_latitude": "33.7522787",
      "poi_longitude": "-84.3952065",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-574-5680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f429db354b49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f429db354b49",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f429db354b49.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJQEcinkD9YgRw46X2vrQ7rA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_685b8819be209bbb1e118ac8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Old Lady Gang Southern Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "177 Peters St SW, Atlanta, GA 30313, USA",
      "poi_short_description": "Buzzy spot for soul food classics and southern eats, plus Sunday brunch.",
      "poi_long_description": "Buzzy spot for soul food classics and southern eats, plus Sunday brunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-7ce4-72ef-a351-112ba99136ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-7ce4-72ef-a351-112ba99136ea",
        "storage_key": "property/6767906449167721/01a02099-7ce4-72ef-a351-112ba99136ea.webp",
        "width": 988,
        "height": 1280
      },
      "poi_business_url": "http://oldladygang.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13988957555736615977&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-lady-gang-southern-cuisine",
      "poi_latitude": "33.7496908",
      "poi_longitude": "-84.3993405",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 404-748-9689",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f429db354b49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f429db354b49",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f429db354b49.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR5IXsXkD9YgRKZyyv8fCIsI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_dcf4acb02d4fc3c535eaf389",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Atlantucky Brewing",
      "poi_type": "Restaurants",
      "poi_address": "170 Northside Dr SW Ste 96, Atlanta, GA 30313, USA",
      "poi_short_description": "Cool brewery with an art gallery feel and many beers on tap, plus pizza.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-7d77-7629-8cb4-1949ae7ab3db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-7d77-7629-8cb4-1949ae7ab3db",
        "storage_key": "property/6767906449167721/01a02099-7d77-7629-8cb4-1949ae7ab3db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://atlantucky.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=8046214204770520403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlantucky-brewing",
      "poi_latitude": "33.7500392",
      "poi_longitude": "-84.4033955",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 678-705-2630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f9a96eb1295a",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU8A-j4kD9YgRU40MRjDlqW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "ec_bf23b798c17aaf171340052b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Fellaship.ATL",
      "poi_type": "Restaurants",
      "poi_address": "110 Centennial Olympic Park Dr Ste 102-104, Atlanta, GA 30313, USA",
      "poi_short_description": "Elegant space for Southern fine dining, cocktails & cigars, plus live jazz & DJs.",
      "poi_long_description": "Elegant space for Southern fine dining, cocktails & cigars, plus live jazz & DJs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-7a29-704c-b97b-f9781947f25d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-7a29-704c-b97b-f9781947f25d",
        "storage_key": "property/6767906449167721/01a02099-7a29-704c-b97b-f9781947f25d.webp",
        "width": 1000,
        "height": 647
      },
      "poi_business_url": "https://fellashipatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3532671957153929880&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fellashipatl",
      "poi_latitude": "33.7521147",
      "poi_longitude": "-84.39904419999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-254-4970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-cc8e-732e-bfec-b74ce6165f2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02099-cc8e-732e-bfec-b74ce6165f2a",
        "storage_key": "property/6767906449167721/01a02099-cc8e-732e-bfec-b74ce6165f2a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9XafIfoD9YgRmNokmm2SBjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_3b6c5fc38f374c2cc0742daa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "The Sun Dial Restaurant, Bar & View",
      "poi_type": "Restaurants",
      "poi_address": "210 Peachtree St NW, Atlanta, GA 30303, USA",
      "poi_short_description": "Hotel restaurant & bar with 360-degree views of the city, featuring seasonal American cuisine.",
      "poi_long_description": "Hotel restaurant & bar with 360-degree views of the city, featuring seasonal American cuisine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-7b01-779b-9ee2-5699e197291e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-7b01-779b-9ee2-5699e197291e",
        "storage_key": "property/6767906449167721/01a02099-7b01-779b-9ee2-5699e197291e.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.marriott.com/en-us/hotels/atlpl-the-westin-peachtree-plaza-atlanta/dining/?scid=feed67b0-9a2f-4de1-8df6-114544116108",
      "poi_directions_map_url": "https://maps.google.com/?cid=8145147749607297368&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-sun-dial-restaurant-bar--view",
      "poi_latitude": "33.7595838",
      "poi_longitude": "-84.38857039999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-589-7506",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f429db354b49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f429db354b49",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f429db354b49.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ86lMh3gE9YgRWFFqMrlgCXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_7e926829fdb2aa72d262e756",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "The Boxcar Grocer",
      "poi_type": "Shopping & Retail",
      "poi_address": "249 Peters St SW, Atlanta, GA 30313, USA",
      "poi_short_description": "Featuring a cafe with free WiFi, this family-owned market carrries name-brand & artisanal goods.",
      "poi_long_description": "Featuring a cafe with free WiFi, this family-owned market carrries name-brand & artisanal goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-7ded-77e8-8154-d6bbb66078ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-7ded-77e8-8154-d6bbb66078ae",
        "storage_key": "property/6767906449167721/01a02099-7ded-77e8-8154-d6bbb66078ae.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6247324436258474421&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-boxcar-grocer",
      "poi_latitude": "33.7479245",
      "poi_longitude": "-84.4015965",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-883-3608",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a5d-77f5-a1cf-b00f03435972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a5d-77f5-a1cf-b00f03435972",
        "storage_key": "property/6767906449167721/01a02097-3a5d-77f5-a1cf-b00f03435972.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWx1GqnAD9YgRtcnNm3n0slY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_a0846b06a6f6ac07c3651b25",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Castleberry Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "99 Centennial Olympic Park Dr NW, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-8261-72d5-8397-40ef2d50702f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-8261-72d5-8397-40ef2d50702f",
        "storage_key": "property/6767906449167721/01a02099-8261-72d5-8397-40ef2d50702f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.castleberrymarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5186911772403831032&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "castleberry-market",
      "poi_latitude": "33.7537579",
      "poi_longitude": "-84.400446",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 770-758-7830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3abe-773c-b9a5-78c647357b96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3abe-773c-b9a5-78c647357b96",
        "storage_key": "property/6767906449167721/01a02097-3abe-773c-b9a5-78c647357b96.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJy0PbnN0D9YgR-BBsi8ac-0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farmers_market"
    },
    {
      "id": "ec_6143c022cfe887606540ea09",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "THE PINK ZEBRA BOUTIQUE + SOCIAL",
      "poi_type": "Shopping & Retail",
      "poi_address": "177 Peters St SW Ste C, Atlanta, GA 30313, USA",
      "poi_short_description": "Colorful store featuring unique women's clothing, plus shoes, handbags & accessories.",
      "poi_long_description": "Colorful store featuring unique women's clothing, plus shoes, handbags & accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-8168-72ee-a601-36e06350aa8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-8168-72ee-a601-36e06350aa8d",
        "storage_key": "property/6767906449167721/01a02099-8168-72ee-a601-36e06350aa8d.webp",
        "width": 1014,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/share/1A7qo7uXSJ/?mibextid=LQQJ4d",
      "poi_directions_map_url": "https://maps.google.com/?cid=8780759926660083237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-pink-zebra-boutique--social",
      "poi_latitude": "33.7497104",
      "poi_longitude": "-84.3993804",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 678-634-9492",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3abe-773c-b9a5-78c647357b96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3abe-773c-b9a5-78c647357b96",
        "storage_key": "property/6767906449167721/01a02097-3abe-773c-b9a5-78c647357b96.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ3Y8SIKkG9YgRJS6PfqGG23k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "ec_4d4cbc0139c798e624292290",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "No Mas! Hacienda Artisan Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "180 Walker St SW Ste A, Atlanta, GA 30313, USA",
      "poi_short_description": "Huge Mexican outpost that's part clothing shop, part furniture & interiors store & part restaurant.",
      "poi_long_description": "Huge Mexican outpost that's part clothing shop, part furniture & interiors store & part restaurant.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-8261-72d5-8397-474db064ca7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-8261-72d5-8397-474db064ca7d",
        "storage_key": "property/6767906449167721/01a02099-8261-72d5-8397-474db064ca7d.webp",
        "width": 1280,
        "height": 707
      },
      "poi_business_url": "https://nomasproductions.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17504656497069028466&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "no-mas-hacienda-artisan-market",
      "poi_latitude": "33.7497678",
      "poi_longitude": "-84.40102759999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-215-9769",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3abe-773c-b9a5-78c647357b96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3abe-773c-b9a5-78c647357b96",
        "storage_key": "property/6767906449167721/01a02097-3abe-773c-b9a5-78c647357b96.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJQEcinkD9YgRcnQIJ1cI7fI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "ec_a58832554406809596de92fa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "925.MX Silver Jewelry",
      "poi_type": "Shopping & Retail",
      "poi_address": "180 Walker St SW Ste e, Atlanta, GA 30313, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-84e4-77f3-96d7-a6db0117c3d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-84e4-77f3-96d7-a6db0117c3d2",
        "storage_key": "property/6767906449167721/01a02099-84e4-77f3-96d7-a6db0117c3d2.webp",
        "width": 1280,
        "height": 707
      },
      "poi_business_url": "https://www.925.mx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5261510859711965435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "925mx-silver-jewelry",
      "poi_latitude": "33.7498423",
      "poi_longitude": "-84.40100450000001",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-350-0116",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3abe-773c-b9a5-78c647357b96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3abe-773c-b9a5-78c647357b96",
        "storage_key": "property/6767906449167721/01a02097-3abe-773c-b9a5-78c647357b96.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJxFIjnkD9YgR--j9DkCkBEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "jewelry_store"
    },
    {
      "id": "ec_163023a865fc7a7b06708b68",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Atlanta Furniture Company",
      "poi_type": "Shopping & Retail",
      "poi_address": "275 Peters St SW Unit A, Atlanta, GA 30313, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-8278-70ea-b52e-9b739a1a9070.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-8278-70ea-b52e-9b739a1a9070",
        "storage_key": "property/6767906449167721/01a02099-8278-70ea-b52e-9b739a1a9070.webp",
        "width": 750,
        "height": 726
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=778124843890572091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlanta-furniture-company",
      "poi_latitude": "33.7468365",
      "poi_longitude": "-84.40342869999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-980-3119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3abe-773c-b9a5-78c647357b96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3abe-773c-b9a5-78c647357b96",
        "storage_key": "property/6767906449167721/01a02097-3abe-773c-b9a5-78c647357b96.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLUaGg_ED9YgRO_sAP2x0zAo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "ec_2c717b0b72ecf54aec840b22",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "895 Ralph David Abernathy Blvd SW, Atlanta, GA 30310, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-88a2-76bc-a026-5852122cf68c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-88a2-76bc-a026-5852122cf68c",
        "storage_key": "property/6767906449167721/01a02099-88a2-76bc-a026-5852122cf68c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/atlanta-ga-pharmacies/895-ralph-abernathy-blvd-sw-atlanta-ga-30310/storeid=4178?WT.mc_id=LS_GOOGLE_FS_4178",
      "poi_directions_map_url": "https://maps.google.com/?cid=13923556401690821385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "33.7383967",
      "poi_longitude": "-84.4174087",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-755-1511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f9a96eb1295a",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN3XfAkAD9YgRCcPl9MZoOsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_43043c7846c583081c1444b3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "D&M Package",
      "poi_type": "Shopping & Retail",
      "poi_address": "595 Ralph David Abernathy Blvd SW, Atlanta, GA 30312, USA",
      "poi_short_description": "Liquor store offering a selection of alcohol, including beer, wine, and mixers, plus tobacco products.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-866a-74ff-bfc8-deb3c68f6f61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-866a-74ff-bfc8-deb3c68f6f61",
        "storage_key": "property/6767906449167721/01a02099-866a-74ff-bfc8-deb3c68f6f61.webp",
        "width": 1280,
        "height": 663
      },
      "poi_business_url": "https://dandmpackagestore.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3438630115346939102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dm-package",
      "poi_latitude": "33.7380021",
      "poi_longitude": "-84.407231",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-755-3670",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3abe-773c-b9a5-78c647357b96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3abe-773c-b9a5-78c647357b96",
        "storage_key": "property/6767906449167721/01a02097-3abe-773c-b9a5-78c647357b96.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJY9MWm0D9YgR3vw2C993uC8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "ec_6b29b81ddf6c3b633f3db21b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "AK Food Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "1981 Joseph E. Boone Blvd NW, Atlanta, GA 30314, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-864d-7163-8445-5476b64548b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-864d-7163-8445-5476b64548b2",
        "storage_key": "property/6767906449167721/01a02099-864d-7163-8445-5476b64548b2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13231929944314322468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ak-food-store",
      "poi_latitude": "33.7648585",
      "poi_longitude": "-84.4517473",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-794-5295",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-cc96-740b-b470-fe44e01e9f1e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02099-cc96-740b-b470-fe44e01e9f1e",
        "storage_key": "property/6767906449167721/01a02099-cc96-740b-b470-fe44e01e9f1e.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJjXnwBVkb9YgRJJ61ty1Cobc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_f19d3d6afb0de9f02c492ecf",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Centennial Academy Charter School",
      "poi_type": "Education",
      "poi_address": "531 Luckie St NW, Atlanta, GA 30313, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-8cf5-742b-90df-2d84e61053d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-8cf5-742b-90df-2d84e61053d8",
        "storage_key": "property/6767906449167721/01a02099-8cf5-742b-90df-2d84e61053d8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.centennialacademycharter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11758874460627942836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-academy-charter-school",
      "poi_latitude": "33.7696876",
      "poi_longitude": "-84.39518009999999",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-802-8550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a84-735c-aab1-81a485b789ae",
        "storage_key": "property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJATHnVH0E9YgRtD0kUAXqL6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_90c316285f551cdb3e7e999b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Dunbar Elementary School",
      "poi_type": "Education",
      "poi_address": "500 Whitehall Ter SW, Atlanta, GA 30312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.atlantapublicschools.us/Domain/1036",
      "poi_directions_map_url": "https://maps.google.com/?cid=15253113551465209917&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dunbar-elementary-school",
      "poi_latitude": "33.7414139",
      "poi_longitude": "-84.4011056",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-802-7950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a84-735c-aab1-81a485b789ae",
        "storage_key": "property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG6RJBnQD9YgRPeDH6fXxrdM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_0fab12aa97b491f2a7ee137b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Martin Luther King, Jr. Middle School",
      "poi_type": "Education",
      "poi_address": "545 Hill St SE, Atlanta, GA 30312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-8e8a-760d-9b1d-0c18885b9aea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-8e8a-760d-9b1d-0c18885b9aea",
        "storage_key": "property/6767906449167721/01a02099-8e8a-760d-9b1d-0c18885b9aea.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://king.atlantapublicschools.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13452209740910446970&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "martin-luther-king-jr-middle-school",
      "poi_latitude": "33.7385351",
      "poi_longitude": "-84.3798814",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-802-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a84-735c-aab1-81a485b789ae",
        "storage_key": "property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1ZuZT74D9YgRekkEi3zZr7o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_920dd0fda2ca57b64075a417",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Booker T. Washington High School",
      "poi_type": "Education",
      "poi_address": "45 Whitehouse Dr SW, Atlanta, GA 30314, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-8a8d-7347-85eb-3079381cddc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-8a8d-7347-85eb-3079381cddc9",
        "storage_key": "property/6767906449167721/01a02099-8a8d-7347-85eb-3079381cddc9.webp",
        "width": 1240,
        "height": 827
      },
      "poi_business_url": "https://www.atlantapublicschools.us/Domain/904",
      "poi_directions_map_url": "https://maps.google.com/?cid=3778503342046736915&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "booker-t-washington-high-school",
      "poi_latitude": "33.75359110000001",
      "poi_longitude": "-84.4203568",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-802-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a84-735c-aab1-81a485b789ae",
        "storage_key": "property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQUTVzF0D9YgRE3JSLcXwbzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_e56c3388a459952610f7de42",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Atlanta College and Career Academy at the Dr. Michael S. Maze Campus",
      "poi_type": "Education",
      "poi_address": "1090 Windsor St SW, Atlanta, GA 30310, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-8e78-703f-8863-2363801a1cb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-8e78-703f-8863-2363801a1cb3",
        "storage_key": "property/6767906449167721/01a02099-8e78-703f-8863-2363801a1cb3.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.atlantapublicschools.us/acca",
      "poi_directions_map_url": "https://maps.google.com/?cid=11135189820083351566&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlanta-college-and-career-academy-at-the-dr-michael-s-maze-campus",
      "poi_latitude": "33.7251299",
      "poi_longitude": "-84.3982233",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-802-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a84-735c-aab1-81a485b789ae",
        "storage_key": "property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7a5bE-ID9YgRDjCdBCUkiJo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_1ab6564312961e72b81f390a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Arthur M. Blank Family Youth YMCA",
      "poi_type": "Major Employers & Offices",
      "poi_address": "555 Luckie St NW, Atlanta, GA 30313, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-934a-77ad-b710-50fdb309455e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-934a-77ad-b710-50fdb309455e",
        "storage_key": "property/6767906449167721/01a02099-934a-77ad-b710-50fdb309455e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://ymcaatlanta.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16456827433167491737&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arthur-m-blank-family-youth-ymca",
      "poi_latitude": "33.7703472",
      "poi_longitude": "-84.3954736",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-724-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a84-735c-aab1-81a485b789ae",
        "storage_key": "property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAXSxq2IE9YgRmRLaw1tlYuQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_a206767694d1efa07bee9237",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Centennial Hall",
      "poi_type": "Education",
      "poi_address": "100 Auburn Ave NE, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-9525-715d-a955-1d57de33f077.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-9525-715d-a955-1d57de33f077",
        "storage_key": "property/6767906449167721/01a02099-9525-715d-a955-1d57de33f077.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://events.gsu.edu/centennial-hall/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11547083464942115314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-hall",
      "poi_latitude": "33.7558673",
      "poi_longitude": "-84.3837997",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-413-2063",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a84-735c-aab1-81a485b789ae",
        "storage_key": "property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsb8DWogD9YgR8lmpdzt7P6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "academic_department"
    },
    {
      "id": "ec_e7b797fad3b3fb433a1ca010",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Morehouse College",
      "poi_type": "Education",
      "poi_address": "830 Westview Dr SW, Atlanta, GA 30314, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-934a-77ad-b710-4cb3aec7c689.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-934a-77ad-b710-4cb3aec7c689",
        "storage_key": "property/6767906449167721/01a02099-934a-77ad-b710-4cb3aec7c689.webp",
        "width": 1250,
        "height": 557
      },
      "poi_business_url": "http://www.morehouse.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14622133378457031593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morehouse-college",
      "poi_latitude": "33.7473412",
      "poi_longitude": "-84.415528",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 470-639-0999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a84-735c-aab1-81a485b789ae",
        "storage_key": "property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi_Hxq0ID9YgRqVNQGdZA7Mo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_7c63235be944ad70396dbe66",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Spelman College",
      "poi_type": "Education",
      "poi_address": "350 Spelman Ln SW, Atlanta, GA 30314, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-914e-756d-99ec-d5b237ca438b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-914e-756d-99ec-d5b237ca438b",
        "storage_key": "property/6767906449167721/01a02099-914e-756d-99ec-d5b237ca438b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.spelman.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17929322583875747606&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spelman-college",
      "poi_latitude": "33.7451954",
      "poi_longitude": "-84.4114376",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-681-3643",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a84-735c-aab1-81a485b789ae",
        "storage_key": "property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe4xn2m4D9YgRFn9Ne-W_0fg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_aa5d056d1aa9f34ee1d5ab4a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Clark Atlanta University",
      "poi_type": "Education",
      "poi_address": "223 James P Brawley Dr SW, Atlanta, GA 30314, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-9608-779b-b5a4-82ce76cf73eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-9608-779b-b5a4-82ce76cf73eb",
        "storage_key": "property/6767906449167721/01a02099-9608-779b-b5a4-82ce76cf73eb.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.cau.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8436332299606813128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clark-atlanta-university",
      "poi_latitude": "33.7515658",
      "poi_longitude": "-84.4112315",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-880-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a84-735c-aab1-81a485b789ae",
        "storage_key": "property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAQAwoWgD9YgRyOk3ZYffE3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_3cb0c40257dc7b5535aa6586",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Georgia Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "225 Baker St NW, Atlanta, GA 30313, USA",
      "poi_short_description": "One of world's largest aquariums, with permanent exhibits, interactive galleries & animals galore.",
      "poi_long_description": "One of world's largest aquariums, with permanent exhibits, interactive galleries & animals galore.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02096-fec5-7024-b452-2da08638298e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02096-fec5-7024-b452-2da08638298e",
        "storage_key": "property/6767906449167721/01a02096-fec5-7024-b452-2da08638298e.webp",
        "width": 1280,
        "height": 1148
      },
      "poi_business_url": "https://www.georgiaaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18363269660581776092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-aquarium",
      "poi_latitude": "33.763382",
      "poi_longitude": "-84.3951098",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-581-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a24-723a-8797-ab5d917ebbaa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a24-723a-8797-ab5d917ebbaa",
        "storage_key": "property/6767906449167721/01a02097-3a24-723a-8797-ab5d917ebbaa.webp",
        "width": 192,
        "height": 176
      },
      "poi_google_place_id": "ChIJGQT0RX4E9YgR3EqvqXZw1_4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "ec_ba97f39e5e40ceb06660fdf8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "World of Coca-Cola",
      "poi_type": "Entertainment",
      "poi_address": "121 Baker St NW, Atlanta, GA 30313, USA",
      "poi_short_description": "Memorabilia, films & exhibits (some interactive) about soft drink that debuted in Atlanta in 1886.",
      "poi_long_description": "Memorabilia, films & exhibits (some interactive) about soft drink that debuted in Atlanta in 1886.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-07c8-70f6-b898-63195fcab03f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02097-07c8-70f6-b898-63195fcab03f",
        "storage_key": "property/6767906449167721/01a02097-07c8-70f6-b898-63195fcab03f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.worldofcoca-cola.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4900394244069369801&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "world-of-coca-cola",
      "poi_latitude": "33.7625564",
      "poi_longitude": "-84.39243599999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-676-5151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a24-723a-8797-afac00d5da54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a24-723a-8797-afac00d5da54",
        "storage_key": "property/6767906449167721/01a02097-3a24-723a-8797-afac00d5da54.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8yjI7H4E9YgRyacfAZqyAUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_985eae70b940bab4d64624ec",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "National Center for Civil and Human Rights",
      "poi_type": "Entertainment",
      "poi_address": "100 Ivan Allen Jr Blvd NW, Atlanta, GA 30313, USA",
      "poi_short_description": "Cultural attraction presents artifacts, art & photos from the Civil Rights Era & about human rights.",
      "poi_long_description": "Cultural attraction presents artifacts, art & photos from the Civil Rights Era & about human rights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-96be-73a5-86d5-c70acfdf2520.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-96be-73a5-86d5-c70acfdf2520",
        "storage_key": "property/6767906449167721/01a02099-96be-73a5-86d5-c70acfdf2520.webp",
        "width": 1280,
        "height": 868
      },
      "poi_business_url": "http://www.civilandhumanrights.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4518915228714863530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-center-for-civil-and-human-rights",
      "poi_latitude": "33.7640278",
      "poi_longitude": "-84.39307219999999",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 678-999-8990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f9a96eb1295a",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPRzoQ4AE9YgRqgunUXVptj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "ec_ec3cead71cf3b925735612f9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Centennial Olympic Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Atlanta, GA 30313, USA",
      "poi_short_description": "Home of the 1996 Olympic games now filled with walking paths, water gardens & the Fountain of Rings.",
      "poi_long_description": "Home of the 1996 Olympic games now filled with walking paths, water gardens & the Fountain of Rings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-1e08-7249-886e-b47080386883.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02097-1e08-7249-886e-b47080386883",
        "storage_key": "property/6767906449167721/01a02097-1e08-7249-886e-b47080386883.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gwcca.org/centennial-olympic-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6004367012448251227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-olympic-park",
      "poi_latitude": "33.760463",
      "poi_longitude": "-84.3930831",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-223-4412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a84-735c-aab1-850ce82023ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a84-735c-aab1-850ce82023ff",
        "storage_key": "property/6767906449167721/01a02097-3a84-735c-aab1-850ce82023ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIRYhpn8E9YgRWy0NPvzLU1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_7f9bf5a7b2442ac302a1712d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "State Farm Arena",
      "poi_type": "Entertainment",
      "poi_address": "1 State Farm Dr, Atlanta, GA 30303, USA",
      "poi_short_description": "Home of the Hawks & the Dream, this state-of-the-art venue also hosts concerts & special events.",
      "poi_long_description": "Home of the Hawks & the Dream, this state-of-the-art venue also hosts concerts & special events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-048a-77fc-8926-ea2b3a7ff270.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02097-048a-77fc-8926-ea2b3a7ff270",
        "storage_key": "property/6767906449167721/01a02097-048a-77fc-8926-ea2b3a7ff270.webp",
        "width": 1080,
        "height": 620
      },
      "poi_business_url": "https://www.statefarmarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12709393292767748091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "state-farm-arena",
      "poi_latitude": "33.7574062",
      "poi_longitude": "-84.396233",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-878-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f9a96eb1295a",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbUlCkX8D9YgR-18nztzVYLA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "ec_72667fea7ada29f96b1bd4a0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Mercedes-Benz Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1 AMB Dr NW, Atlanta, GA 30313, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-0809-717a-889a-f5224c043036.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02097-0809-717a-889a-f5224c043036",
        "storage_key": "property/6767906449167721/01a02097-0809-717a-889a-f5224c043036.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://mercedesbenzstadium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7296321780679831790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercedes-benz-stadium",
      "poi_latitude": "33.7553232",
      "poi_longitude": "-84.40059049999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 470-341-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a21-73e8-a098-1323571a2389.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a21-73e8-a098-1323571a2389",
        "storage_key": "property/6767906449167721/01a02097-3a21-73e8-a098-1323571a2389.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ45nHOHwD9YgR7vBdgAC-QWU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "ec_b060a7611a1c18b0dfe143b8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "SkyView Atlanta",
      "poi_type": "Entertainment",
      "poi_address": "168 Luckie St NW, Atlanta, GA 30303, USA",
      "poi_short_description": "20-story Ferris wheel in Centennial Park providing scenic views from climate-controlled gondolas.",
      "poi_long_description": "20-story Ferris wheel in Centennial Park providing scenic views from climate-controlled gondolas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-9d68-73ad-8178-6ce286bde624.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-9d68-73ad-8178-6ce286bde624",
        "storage_key": "property/6767906449167721/01a02099-9d68-73ad-8178-6ce286bde624.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.skyviewatlanta.com/?y_source=1_MjAzNDY3MjQwNi03MTUtbG9jYXRpb24ud2Vic2l0ZQ==",
      "poi_directions_map_url": "https://maps.google.com/?cid=4285968454858021836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skyview-atlanta",
      "poi_latitude": "33.7589378",
      "poi_longitude": "-84.3916921",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-949-9023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f9a96eb1295a",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3ShBWX8E9YgRzJtXBprRejs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ferris_wheel"
    },
    {
      "id": "ec_23f4d0d6cecab55ba88ad7f1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Tabernacle",
      "poi_type": "Entertainment",
      "poi_address": "152 Luckie St NW, Atlanta, GA 30303, USA",
      "poi_short_description": "Wide range of acts perform at old church (ca. 1910) turned swank music venue with booze & bar bites.",
      "poi_long_description": "Wide range of acts perform at old church (ca. 1910) turned swank music venue with booze & bar bites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-9b77-7769-b4b5-f2b1c466a3b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-9b77-7769-b4b5-f2b1c466a3b0",
        "storage_key": "property/6767906449167721/01a02099-9b77-7769-b4b5-f2b1c466a3b0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.tabernacleatl.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=17048375409725775301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tabernacle",
      "poi_latitude": "33.7588551",
      "poi_longitude": "-84.39140569999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-659-9022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f9a96eb1295a",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Q3ZVn8E9YgRxZ015hv_l-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_64445d916505e43857fad23d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "College Football Hall of Fame",
      "poi_type": "Entertainment",
      "poi_address": "250 Marietta St NW, Atlanta, GA 30313, USA",
      "poi_short_description": "Sleek modern museum offers exhibits on famous college football players & an indoor field for events.",
      "poi_long_description": "Sleek modern museum offers exhibits on famous college football players & an indoor field for events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-9be1-755e-ab29-6a8b2995959a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-9be1-755e-ab29-6a8b2995959a",
        "storage_key": "property/6767906449167721/01a02099-9be1-755e-ab29-6a8b2995959a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cfbhall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17894291972466819922&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "college-football-hall-of-fame",
      "poi_latitude": "33.760276",
      "poi_longitude": "-84.39537330000002",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-880-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a24-723a-8797-afac00d5da54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a24-723a-8797-afac00d5da54",
        "storage_key": "property/6767906449167721/01a02097-3a24-723a-8797-afac00d5da54.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJNRnJ3H8E9YgRUkMCrr1LVfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_301f56d556001b9356d15e5a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Children's Museum of Atlanta",
      "poi_type": "Entertainment",
      "poi_address": "275 Centennial Olympic Park Dr NW, Atlanta, GA 30313, USA",
      "poi_short_description": "Recommended for kids age 2-8, this hands-on museum features an indoor playground, sand table & more.",
      "poi_long_description": "Recommended for kids age 2-8, this hands-on museum features an indoor playground, sand table & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-9d6d-71d8-b7eb-930a29962f29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-9d6d-71d8-b7eb-930a29962f29",
        "storage_key": "property/6767906449167721/01a02099-9d6d-71d8-b7eb-930a29962f29.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://childrensmuseumatlanta.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9123950400928075176&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-museum-of-atlanta",
      "poi_latitude": "33.7625707",
      "poi_longitude": "-84.39173269999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-659-5437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a24-723a-8797-afac00d5da54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a24-723a-8797-afac00d5da54",
        "storage_key": "property/6767906449167721/01a02097-3a24-723a-8797-afac00d5da54.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ38j8xX4E9YgRqM2Zg4zInn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_e64e8da3d0cb9afb23de8ceb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Grady Memorial Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "80 Jesse Hill Jr Dr SE, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-1632-746d-ac12-8fc082a9ca73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02097-1632-746d-ac12-8fc082a9ca73",
        "storage_key": "property/6767906449167721/01a02097-1632-746d-ac12-8fc082a9ca73.webp",
        "width": 1200,
        "height": 400
      },
      "poi_business_url": "https://www.gradyhealth.org/?utm_source=gmb&utm_medium=organic&utm_campaign=sitelink&utm_id=grady",
      "poi_directions_map_url": "https://maps.google.com/?cid=7804908829099084763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grady-memorial-hospital",
      "poi_latitude": "33.7517861",
      "poi_longitude": "-84.3820111",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-616-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a23-720d-95bf-0491493f5631.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a23-720d-95bf-0491493f5631",
        "storage_key": "property/6767906449167721/01a02097-3a23-720d-95bf-0491493f5631.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Rc8z44D9YgR28vCVjqbUGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_519d63d62027b8758a6b04a9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Emory University Hospital Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "550 Peachtree St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-1822-77db-a009-b6ddf2bea1d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02097-1822-77db-a009-b6ddf2bea1d2",
        "storage_key": "property/6767906449167721/01a02097-1822-77db-a009-b6ddf2bea1d2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.emoryhealthcare.org/locations/hospitals/emory-university-hospital-midtown?&utm_campaign=brand_euh_ra_gmb-locations&utm_source=google&utm_medium=gmb&utm_content=gmb_locations?&utm_campaign=brand_all_non&utm_source=google&utm_medium=gmb&utm_content=gmb-locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=15043808532116501154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emory-university-hospital-midtown",
      "poi_latitude": "33.7686442",
      "poi_longitude": "-84.38619290000001",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-686-4411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a23-720d-95bf-0491493f5631.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a23-720d-95bf-0491493f5631",
        "storage_key": "property/6767906449167721/01a02097-3a23-720d-95bf-0491493f5631.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ42AWonoE9YgRonLLiSdYxtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_f35154147f1d1a00dcb6b128",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Urgent Care 24/7 Atlanta",
      "poi_type": "Health and Wellness",
      "poi_address": "285 Centennial Olympic Park Dr NW CU-2A, Atlanta, GA 30313, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-a336-73ec-80d5-4fd86bdd3cad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-a336-73ec-80d5-4fd86bdd3cad",
        "storage_key": "property/6767906449167721/01a02099-a336-73ec-80d5-4fd86bdd3cad.webp",
        "width": 1080,
        "height": 1156
      },
      "poi_business_url": "https://www.urgentcare247.com/locations/urgent-care-24-7-atlanta",
      "poi_directions_map_url": "https://maps.google.com/?cid=13279183964562671397&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urgent-care-247-atlanta",
      "poi_latitude": "33.762603",
      "poi_longitude": "-84.39172",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 470-809-1584",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f9a96eb1295a",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Rg6xn4E9YgRJUfSqnUjSbg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_5ea288264c6e1b39fb8ca8ea",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "235 Peachtree Rd NE STE C24, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-a403-77ee-82be-8107a6b97ecb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-a403-77ee-82be-8107a6b97ecb",
        "storage_key": "property/6767906449167721/01a02099-a403-77ee-82be-8107a6b97ecb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/atlanta-ga-pharmacies/235-peachtree-st-ne-suite-c24-atlanta-ga-30303/storeid=10043?WT.mc_id=LS_GOOGLE_RX_10043",
      "poi_directions_map_url": "https://maps.google.com/?cid=7830701934035987352&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.7605323",
      "poi_longitude": "-84.3872341",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-577-4054",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-cca0-76c3-8dbb-6949d9a8c946.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02099-cca0-76c3-8dbb-6949d9a8c946",
        "storage_key": "property/6767906449167721/01a02099-cca0-76c3-8dbb-6949d9a8c946.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLc0yRngE9YgRmOstkOs9rGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_75e4d7e18f254cd58af1578c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "595 Piedmont Ave NE Ste 100, Atlanta, GA 30308, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-a4ba-70a7-8345-58cad8f2bf63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-a4ba-70a7-8345-58cad8f2bf63",
        "storage_key": "property/6767906449167721/01a02099-a4ba-70a7-8345-58cad8f2bf63.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-595+piedmont+ave+ne-atlanta-ga-30308/id=6032",
      "poi_directions_map_url": "https://maps.google.com/?cid=10791041622720626702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "33.770849",
      "poi_longitude": "-84.381102",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-685-9665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-cca0-76c3-8dbb-6949d9a8c946.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02099-cca0-76c3-8dbb-6949d9a8c946",
        "storage_key": "property/6767906449167721/01a02099-cca0-76c3-8dbb-6949d9a8c946.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRRGnEm4E9YgRDsC3ti57wZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_cd5893a462de6f9f1ff8e6dc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "evolation yoga atlanta",
      "poi_type": "Health and Wellness",
      "poi_address": "950 W Peachtree St NW Unit 210, Atlanta, GA 30309, USA",
      "poi_short_description": "Clean studio for hot and Bikram yoga classes, plus locker rooms and showers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-a2eb-725d-b56a-571107c2494e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-a2eb-725d-b56a-571107c2494e",
        "storage_key": "property/6767906449167721/01a02099-a2eb-725d-b56a-571107c2494e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.evolationyogaatlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12648502523646421058&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "evolation-yoga-atlanta",
      "poi_latitude": "33.779664",
      "poi_longitude": "-84.3878387",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a84-735c-aab1-81a485b789ae",
        "storage_key": "property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0yYAkmcE9YgRQqiT1geCiK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_c30d7a53caf07788fc3afc6c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "CorePower Yoga - Atlanta Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "860 Peachtree St NE Suite J, Atlanta, GA 30308, USA",
      "poi_short_description": "Branch of a fitness chain offering vigorous yoga classes with a focus on mindfulness.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-a4e1-7357-ba38-c1ef9028e90d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-a4e1-7357-ba38-c1ef9028e90d",
        "storage_key": "property/6767906449167721/01a02099-a4e1-7357-ba38-c1ef9028e90d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.corepoweryoga.com/yoga-studios/ga/atlanta/atlanta-midtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=3395339368669349519&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corepower-yoga---atlanta-midtown",
      "poi_latitude": "33.7784663",
      "poi_longitude": "-84.38542319999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 833-448-2561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a84-735c-aab1-81a485b789ae",
        "storage_key": "property/6767906449167721/01a02097-3a84-735c-aab1-81a485b789ae.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZUNWe2gE9YgRj4ZvoSqrHi8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_aa209282fa0e1a69cd1561ce",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "75 5th St NW Ste E, Atlanta, GA 30332, USA",
      "poi_short_description": "Clean, spacious, nationwide chain featuring cardio machines, free weights and personal training.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-0f8f-7669-a2c6-2e7a8ad3be28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02097-0f8f-7669-a2c6-2e7a8ad3be28",
        "storage_key": "property/6767906449167721/01a02097-0f8f-7669-a2c6-2e7a8ad3be28.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=619&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13589413194811675190&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.77744300000001",
      "poi_longitude": "-84.38912309999999",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 404-212-1065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f9a96eb1295a",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-SOD6GYE9YgRNpLBBk1Ll7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_33fcd210a25d486c86571b44",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "The Home Depot Backyard",
      "poi_type": "Entertainment",
      "poi_address": "1 Backyard Way, Atlanta, GA 30313, USA",
      "poi_short_description": "Outdoor green space hosting free fitness classes and events, plus parking for Atlanta Falcons and Atlanta United games.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-ae8f-701b-bde2-9ba3576fa536.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-ae8f-701b-bde2-9ba3576fa536",
        "storage_key": "property/6767906449167721/01a02099-ae8f-701b-bde2-9ba3576fa536.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thehomedepotbackyard.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7101473532685525358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot-backyard",
      "poi_latitude": "33.7576382",
      "poi_longitude": "-84.4009803",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f9a96eb1295a",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_7OEglID9YgRbiGPgY2AjWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_239599a6c442a3cad778992d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Georgia World Congress Center",
      "poi_type": "Entertainment",
      "poi_address": "285 Andrew Young International Blvd NW, Atlanta, GA 30313, USA",
      "poi_short_description": "Huge, architectural marvel presenting a slate of conferences, shows and exhibitions.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-ab0b-73c5-87e6-9fb5b6706ecf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-ab0b-73c5-87e6-9fb5b6706ecf",
        "storage_key": "property/6767906449167721/01a02099-ab0b-73c5-87e6-9fb5b6706ecf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.gwcca.org/georgia-world-congress-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=15144273618014860395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-world-congress-center",
      "poi_latitude": "33.7582368",
      "poi_longitude": "-84.39710610000002",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-223-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f9a96eb1295a",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWVKVj4EE9YgRa3QYJ55EK9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_5bd22e17eb4076e5256f6bdb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Rodney Cook Sr. Park in Historic Vine City",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Vine St NW, Atlanta, GA 30314, USA",
      "poi_short_description": "Lush park featuring slides and swings, as well as ponds.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-aa9d-77ba-b4ce-3d8ec6305d8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-aa9d-77ba-b4ce-3d8ec6305d8f",
        "storage_key": "property/6767906449167721/01a02099-aa9d-77ba-b4ce-3d8ec6305d8f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rodney-cook-sr-park-in-historic-vine-city.loopfun.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4545653947455978405&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rodney-cook-sr-park-in-historic-vine-city",
      "poi_latitude": "33.761916",
      "poi_longitude": "-84.408024",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-881-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a84-735c-aab1-850ce82023ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a84-735c-aab1-850ce82023ff",
        "storage_key": "property/6767906449167721/01a02097-3a84-735c-aab1-850ce82023ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6bogIZ0E9YgRpTv3aS5oFT8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_fc32e90d660edcba94ec815d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "June Elois Mundy Park (Vine City Park)",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Magnolia St NW, Atlanta, GA 30314, USA",
      "poi_short_description": "Park features a playground and an open soccer field.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-b095-730f-bf02-862d2cf598d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-b095-730f-bf02-862d2cf598d2",
        "storage_key": "property/6767906449167721/01a02099-b095-730f-bf02-862d2cf598d2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2998777346444221336&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "june-elois-mundy-park-vine-city-park",
      "poi_latitude": "33.7584781",
      "poi_longitude": "-84.4067325",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a84-735c-aab1-850ce82023ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a84-735c-aab1-850ce82023ff",
        "storage_key": "property/6767906449167721/01a02097-3a84-735c-aab1-850ce82023ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRSu5smID9YgRmNtLvxvMnSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_de173ffb2590b98f6efe8f26",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Lindsay Street Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "551 Oliver St NW, Atlanta, GA 30314, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-ab02-743e-9479-76665a09b893.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-ab02-743e-9479-76665a09b893",
        "storage_key": "property/6767906449167721/01a02099-ab02-743e-9479-76665a09b893.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12043789428987232685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lindsay-street-park",
      "poi_latitude": "33.7694882",
      "poi_longitude": "-84.41554149999999",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a84-735c-aab1-850ce82023ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a84-735c-aab1-850ce82023ff",
        "storage_key": "property/6767906449167721/01a02097-3a84-735c-aab1-850ce82023ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDaCyapgE9YgRrYFjyKwiJKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_eafac04652e61a706967968a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "John F. Kennedy Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Atlanta, GA 30314, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5917698212967636628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-f-kennedy-park",
      "poi_latitude": "33.7621698",
      "poi_longitude": "-84.41184989999999",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a84-735c-aab1-850ce82023ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a84-735c-aab1-850ce82023ff",
        "storage_key": "property/6767906449167721/01a02097-3a84-735c-aab1-850ce82023ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAA1Z0E9YgRlF7m3yvjH1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d7cda3d791e41652e2a3e3e6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Woodruff Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "91 Peachtree St, Atlanta, GA 30303, USA",
      "poi_short_description": "City park with 2 fountains, playgrounds, sculptures, chess court & pavilion, plus events.",
      "poi_long_description": "City park with 2 fountains, playgrounds, sculptures, chess court & pavilion, plus events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-b1b3-72d8-a7d5-fc1c94de2a57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-b1b3-72d8-a7d5-fc1c94de2a57",
        "storage_key": "property/6767906449167721/01a02099-b1b3-72d8-a7d5-fc1c94de2a57.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantaga.gov/government/departments/department-parks-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=10797897627385162082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodruff-park",
      "poi_latitude": "33.755217",
      "poi_longitude": "-84.388628",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-546-6744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a84-735c-aab1-850ce82023ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a84-735c-aab1-850ce82023ff",
        "storage_key": "property/6767906449167721/01a02097-3a84-735c-aab1-850ce82023ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXwkh_4YD9YgRYmlTsa7W2ZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_6862810baee4c73d97c07c55",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Historic Fourth Ward Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "680 Dallas St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "A 17-acre park with a splash fountain, skate park & amphitheater, adjacent to the Atlanta Beltline.",
      "poi_long_description": "A 17-acre park with a splash fountain, skate park & amphitheater, adjacent to the Atlanta Beltline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-b06e-75ed-9c46-a91b5da5bf3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-b06e-75ed-9c46-a91b5da5bf3f",
        "storage_key": "property/6767906449167721/01a02099-b06e-75ed-9c46-a91b5da5bf3f.webp",
        "width": 1280,
        "height": 667
      },
      "poi_business_url": "http://www.h4wpc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1819443021458306877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "historic-fourth-ward-park",
      "poi_latitude": "33.7694043",
      "poi_longitude": "-84.3647968",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-546-6813",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a84-735c-aab1-850ce82023ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a84-735c-aab1-850ce82023ff",
        "storage_key": "property/6767906449167721/01a02097-3a84-735c-aab1-850ce82023ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZSnz-A8E9YgRPfcVx8n1Pxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_c083ff955fd9819a139d8aa8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Piedmont Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Atlanta, GA 30309, USA",
      "poi_short_description": "Sprawling park featuring jogging paths, basketball courts, dog parks, a farmers' market & more.",
      "poi_long_description": "Sprawling park featuring jogging paths, basketball courts, dog parks, a farmers' market & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-17b8-7094-b482-9c7a6cb4dc09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02097-17b8-7094-b482-9c7a6cb4dc09",
        "storage_key": "property/6767906449167721/01a02097-17b8-7094-b482-9c7a6cb4dc09.webp",
        "width": 736,
        "height": 485
      },
      "poi_business_url": "https://piedmontpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17559229622006002958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-park",
      "poi_latitude": "33.7879265",
      "poi_longitude": "-84.37216819999999",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 404-875-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a84-735c-aab1-850ce82023ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a84-735c-aab1-850ce82023ff",
        "storage_key": "property/6767906449167721/01a02097-3a84-735c-aab1-850ce82023ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGaxkUDkE9YgRDjUv9U7qrvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_79f2e96cfa57dac81f6d89e3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Garnett",
      "poi_type": "Transportation & Transit",
      "poi_address": "Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-b776-70f1-9f38-849f0a8a6167.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-b776-70f1-9f38-849f0a8a6167",
        "storage_key": "property/6767906449167721/01a02099-b776-70f1-9f38-849f0a8a6167.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://itsmarta.com/Garnett.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15217501936811471453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garnett",
      "poi_latitude": "33.7485324",
      "poi_longitude": "-84.39589989999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3d60-722f-9a5e-d43d92783d0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3d60-722f-9a5e-d43d92783d0e",
        "storage_key": "property/6767906449167721/01a02097-3d60-722f-9a5e-d43d92783d0e.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwwYvYID9YgRXXJ3wGJtL9M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_8ef6152e12ac0bd377683107",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Greyhound Atlanta",
      "poi_type": "Transportation & Transit",
      "poi_address": "232 Forsyth St SW, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-b5fc-7689-8c28-ef1ec91fcf11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-b5fc-7689-8c28-ef1ec91fcf11",
        "storage_key": "property/6767906449167721/01a02099-b5fc-7689-8c28-ef1ec91fcf11.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greyhound.com/bus/atlanta-ga/atlanta-bus-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=18350200424516971449&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-atlanta",
      "poi_latitude": "33.7484667",
      "poi_longitude": "-84.39638769999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f9a96eb1295a",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNbowD3gD9YgRuWuOBBACqf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_b37483d9c8ec4190a401aee3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Five Points MARTA Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "30 Alabama St SW, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-b795-736d-9514-41c583b8810a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-b795-736d-9514-41c583b8810a",
        "storage_key": "property/6767906449167721/01a02099-b795-736d-9514-41c583b8810a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9456548135659215659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "five-points-marta-station",
      "poi_latitude": "33.7539909",
      "poi_longitude": "-84.391697",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f9a96eb1295a",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV048YwAJ9YgRK5tZK21oPIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "ec_68624da94ff6fc76429a3317",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Marta Train Stations",
      "poi_type": "Transportation & Transit",
      "poi_address": "170 Piedmont Ave SE, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-bbc6-7248-9d11-305b47cbcb8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-bbc6-7248-9d11-305b47cbcb8a",
        "storage_key": "property/6767906449167721/01a02099-bbc6-7248-9d11-305b47cbcb8a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1629176437117277612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marta-train-stations",
      "poi_latitude": "33.7502067",
      "poi_longitude": "-84.3860007",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3d60-722f-9a5e-d43d92783d0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3d60-722f-9a5e-d43d92783d0e",
        "storage_key": "property/6767906449167721/01a02097-3d60-722f-9a5e-d43d92783d0e.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJmeGhgYUD9YgRrNXPelb_mxY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_82bcd172a51c35edb74d401e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Peachtree Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "216 Peachtree Rd NE, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-b8b6-736b-890b-9462a904cb6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-b8b6-736b-890b-9462a904cb6a",
        "storage_key": "property/6767906449167721/01a02099-b8b6-736b-890b-9462a904cb6a.webp",
        "width": 1280,
        "height": 862
      },
      "poi_business_url": "https://itsmarta.com/Peachtree-Center.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=968778342906516042&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peachtree-center",
      "poi_latitude": "33.7580702",
      "poi_longitude": "-84.38739059999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3d60-722f-9a5e-d43d92783d0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3d60-722f-9a5e-d43d92783d0e",
        "storage_key": "property/6767906449167721/01a02097-3d60-722f-9a5e-d43d92783d0e.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3RLXaHgE9YgRStIII8XKcQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_082aaee2ce82bef3f2eef87d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "SEC District",
      "poi_type": "Transportation & Transit",
      "poi_address": "100 Centennial Olympic Park Dr NW, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-bf66-700d-a16a-e2bc7d012372.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-bf66-700d-a16a-e2bc7d012372",
        "storage_key": "property/6767906449167721/01a02099-bf66-700d-a16a-e2bc7d012372.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://itsmarta.com/Omni.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6143183905929850805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sec-district",
      "poi_latitude": "33.7565924",
      "poi_longitude": "-84.3967844",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3d60-722f-9a5e-d43d92783d0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3d60-722f-9a5e-d43d92783d0e",
        "storage_key": "property/6767906449167721/01a02097-3d60-722f-9a5e-d43d92783d0e.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ77wFoX8D9YgRtW_Y5jb5QFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_5c1b471e39c61f065132c03b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Atlanta, Georgia",
      "poi_type": "Transportation & Transit",
      "poi_address": "1688 Peachtree Rd NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-c08e-7621-b8b8-214e1cb66891.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-c08e-7621-b8b8-214e1cb66891",
        "storage_key": "property/6767906449167721/01a02099-c08e-7621-b8b8-214e1cb66891.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=ATL",
      "poi_directions_map_url": "https://maps.google.com/?cid=8455012273152189261&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlanta-georgia",
      "poi_latitude": "33.7994122",
      "poi_longitude": "-84.39260329999999",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-cca4-731c-9a95-9976b5f40b18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02099-cca4-731c-9a95-9976b5f40b18",
        "storage_key": "property/6767906449167721/01a02099-cca4-731c-9a95-9976b5f40b18.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJFybLXVQE9YgRTePNqN08VnU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_88ae924c0b40549341e16913",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Hartsfield-Jackson Atlanta International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6000 N Terminal Pkwy Ste 4000, Atlanta, GA 30320, USA",
      "poi_short_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_long_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-bf67-70d8-9366-7649dad9634f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-bf67-70d8-9366-7649dad9634f",
        "storage_key": "property/6767906449167721/01a02099-bf67-70d8-9366-7649dad9634f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690397784234438728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hartsfield-jackson-atlanta-international-airport",
      "poi_latitude": "33.6324187",
      "poi_longitude": "-84.4333116",
      "poi_miles_from_property": "11.3 mi",
      "poi_walking_minutes": "4 hours 9 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 800-897-1910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-ccaa-729e-9346-623285de01a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02099-ccaa-729e-9346-623285de01a4",
        "storage_key": "property/6767906449167721/01a02099-ccaa-729e-9346-623285de01a4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVkD4S_99IgRSLCSGO-jF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_1afab7b5922e73ef17514ebe",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "One Coca-Cola Plaza",
      "poi_type": "Major Employers & Offices",
      "poi_address": "528 Luckie St NW, Atlanta, GA 30313, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-2d8e-7754-a0dc-eecf1c2c7147.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02097-2d8e-7754-a0dc-eecf1c2c7147",
        "storage_key": "property/6767906449167721/01a02097-2d8e-7754-a0dc-eecf1c2c7147.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.coca-colacompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12947067275745438064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "one-coca-cola-plaza",
      "poi_latitude": "33.7711478",
      "poi_longitude": "-84.397268",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-676-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f9a96eb1295a",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv5ISQokD9YgRcCnkPRc5rbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_335f7de468b27e9efbcce891",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "CNN Studio Tours",
      "poi_type": "Major Employers & Offices",
      "poi_address": "190 Marietta St NW, Atlanta, GA 30303, USA",
      "poi_short_description": "Popular tour providing a behind-the-scenes look at the CNN TV news network & how it operates.",
      "poi_long_description": "Popular tour providing a behind-the-scenes look at the CNN TV news network & how it operates.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-c0a1-7279-add1-2196370a9859.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-c0a1-7279-add1-2196370a9859",
        "storage_key": "property/6767906449167721/01a02099-c0a1-7279-add1-2196370a9859.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9930358705618030367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cnn-studio-tours",
      "poi_latitude": "33.758129",
      "poi_longitude": "-84.3943694",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f9a96eb1295a",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd_c_Y4AD9YgRHw-SJKG4z4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "television_studio"
    },
    {
      "id": "ec_6d514fb41623808de8df103f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Georgia-Pacific LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "133 Peachtree St, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-316e-768e-af87-2ef3f4f93e66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02097-316e-768e-af87-2ef3f4f93e66",
        "storage_key": "property/6767906449167721/01a02097-316e-768e-af87-2ef3f4f93e66.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.gp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11832150852454798275&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-pacific-llc",
      "poi_latitude": "33.7575924",
      "poi_longitude": "-84.38681780000002",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-652-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a81-767f-a8d5-f9a96eb1295a",
        "storage_key": "property/6767906449167721/01a02097-3a81-767f-a8d5-f9a96eb1295a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs2ZpsocD9YgRw1NnyYI-NKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_bb7acd8bfc116ec9ba53deba",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "poi_name": "Children's Healthcare of Atlanta - Hughes Spalding Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "35 Jesse Hill Jr Dr SE, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02099-c601-700d-8c79-bd07ecb38397.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a02099-c601-700d-8c79-bd07ecb38397",
        "storage_key": "property/6767906449167721/01a02099-c601-700d-8c79-bd07ecb38397.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.choa.org/locations/hughes-spalding-hospital?cid=_na1_ch-Yx_na3_na4_d-yxll_na6",
      "poi_directions_map_url": "https://maps.google.com/?cid=8960368804594835839&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-healthcare-of-atlanta---hughes-spalding-hospital",
      "poi_latitude": "33.7538256",
      "poi_longitude": "-84.3820382",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-785-5437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02097-3a23-720d-95bf-0491493f5631.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a02097-3a23-720d-95bf-0491493f5631",
        "storage_key": "property/6767906449167721/01a02097-3a23-720d-95bf-0491493f5631.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE0RlP4kD9YgRf-FdJvSfWXw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    }
  ],
  "office_hours": [
    {
      "id": "ec_9dd993a7fee881ad8aa98c73",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_239954408f3ce4a2c2a088d8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_eafa0f3cecd8ef7cde2cc54a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5d53de8a1962c3a5d0b9a1fb",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2b0db05d32a7c43458eca074",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_33081955290f91b0b7ba736f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_be7d258b7e2c3f5114934b5c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "rating": "5",
      "name": "Seven Chaffin",
      "text": "I’ve had a great experience since moving here, and I have to give credit where it’s due—Mr. Lamar is doing an excellent job as property manager. In just a few short months, I’ve seen a noticeable and positive transformation in the community. The property is consistently clean, well-maintained, and clearly being looked after with care and attention.\n\nIt’s refreshing to see someone take pride in their role and actually follow through. His efforts have made a real difference in the overall atmosphere here, and it shows. Keep up the great work!",
      "date": "2026-04-23",
      "title": "false"
    },
    {
      "id": "ec_c59ecead0ec9a1559fd0f869",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "rating": "5",
      "name": "Alonzo Johnson",
      "text": "Smith & Porter provides great accessible living near downtown. The community has lots of amenities and perks and last but not least a great office staff and maintenance team. I don't know what more we could ask for! Highly recommended.",
      "date": "2026-07-10",
      "title": "false"
    },
    {
      "id": "ec_4baf011e951f2d8d6aca0e27",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "rating": "5",
      "name": "Thaaa Juice",
      "text": "I recently had an exceptional experience securing my new apartment at Smith and Porter. I couldn’t be more pleased with both the property and the leasing staff as well as the support I received throughout the process. From the very beginning, my leasing agent went above and beyond to make everything smooth, transparent, and genuinely enjoyable. They were incredibly responsive, patient with all my questions, and made sure I felt confident every step of the way. What stood out the most was their attention to detail and willingness to accommodate my needs. Thank you again to my leasing agent Tavarious as well as the manager Lamarr.",
      "date": "2026-05-01",
      "title": "false"
    },
    {
      "id": "ec_f148bd0b36da01e5bca2c344",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "rating": "4",
      "name": "Chad Zeno",
      "text": "Every place have there pros and cons the community up keep could be better, but the manager of the property Lamar does his best of making sure he meets your needs & that things get done! The maintenance men are pretty cool especially Brodgric they’re good at what they do.",
      "date": "2026-06-10",
      "title": "false"
    },
    {
      "id": "ec_abbfe49e4eb37dc7c44e9704",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "rating": "5",
      "name": "derrick felder",
      "text": "Lamar Hamilton was very patient kind and very hands on with my experience. He should concern and helped me every step of the way. To assure that I got into my apartment. 10 out of 10 hands down the best customer service I’ve had in a while. Thanks Lamar your the best",
      "date": "2026-04-22",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "resort-style-pool-apartments-downtown-atlanta-avenue",
      "search_query": "resort-style pool apartments downtown atlanta",
      "category": "Amenity",
      "h1_title": "Resort-Style Pool Apartments in Downtown",
      "h2_subtitle": "Experience luxury living with our resort-style pool in Downtown Atlanta. Relax and unwind in the heart of the city at The Avenue.",
      "page_copy": "Discover unparalleled luxury at The Avenue, where our stunning resort-style pool offers a serene escape amidst the vibrant pulse of Downtown Atlanta. Dive into relaxation while enjoying downtown living, complemented by our premium apartment features.\n\nNestled in the bustling heart of Atlanta, The Avenue's exclusive amenities include full granite countertops and co-working office spaces, making modern life effortlessly convenient. Unwind by the pool after a busy day or enjoy the spacious elevators and ceiling fan comforts in each bedroom. Se habla Español, ensuring everyone feels at home in our community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort-Style Pool Apartments Downtown ATL",
      "seo_description": "Discover resort-style pool apartments in downtown Atlanta at The Avenue. Luxury living with premium amenities awaits!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "skyline-views-apartments-fulton-county-avenue",
      "search_query": "skyline views apartments fulton county",
      "category": "Amenity",
      "h1_title": "Skyline Views Apartments in Fulton County",
      "h2_subtitle": "Experience breathtaking skyline views at The Avenue. Nestled in Fulton County, our apartments offer stunning vistas and luxury amenities.",
      "page_copy": "Embrace the beauty of city living with the awe-inspiring skyline views at The Avenue, located in the heart of Fulton County. Our apartments offer a perfect vantage point to appreciate Atlanta's breathtaking cityscape, bringing a touch of urban elegance to your everyday life.\n\nThe Avenue combines spectacular views with top-tier amenities, including granite countertops and dedicated co-working spaces. Situated conveniently in Downtown Atlanta, our community features elevators and ceiling fans in bedrooms, enhancing your comfort and convenience. Plus, our team speaks Spanish, welcoming all with open arms.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Skyline Views Apartments in Fulton County, GA",
      "seo_description": "Discover apartments with stunning skyline views in Fulton County at The Avenue. Luxurious living with top amenities awaits you!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "fitness-club-apartments-atlanta-ga-avenue",
      "search_query": "fitness club apartments atlanta ga",
      "category": "Amenity",
      "h1_title": "Fitness Club Apartments in Atlanta, GA",
      "h2_subtitle": "Stay fit and healthy with The Avenue's exclusive fitness club. Located in Atlanta, GA, our amenities cater to an active lifestyle.",
      "page_copy": "At The Avenue, we prioritize wellness and health, offering residents access to a state-of-the-art fitness club right in the heart of Atlanta, GA. Designed to support an active lifestyle, our fitness facilities provide everything you need for a comprehensive workout without leaving home.\n\nExperience the best of Atlanta living with The Avenue's exceptional amenities. In addition to the fitness club, residents enjoy granite countertops, convenient co-working spaces, and the ease of elevators. Our welcoming atmosphere includes Spanish-speaking staff, ensuring a comfortable and inclusive community for all.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Club Apartments in Atlanta, GA",
      "seo_description": "Discover fitness club apartments in Atlanta, GA at The Avenue. Luxury living with top-tier amenities suited for an active lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "in-unit-washer-dryer-apartments-atlanta-avenue",
      "search_query": "in-unit washer dryer apartments atlanta",
      "category": "Amenity",
      "h1_title": "In-Unit Washer Dryer Apartments in Atlanta",
      "h2_subtitle": "Enjoy the convenience of in-unit washer and dryers at The Avenue, situated in the vibrant city of Atlanta. Experience the ease of modern living.",
      "page_copy": "The Avenue offers an unmatched combination of convenience and luxury with in-unit washer and dryer facilities in the ever-bustling Atlanta. Free yourself from the hassle of shared laundry spaces and do your laundry in the comfort and privacy of your own apartment.\n\nLocated in Downtown Atlanta, The Avenue not only provides modern in-unit amenities but also boasts features like granite countertops and spacious co-working areas. Residents benefit from convenient elevator access and bedroom ceiling fans. Our community, where Spanish is spoken, ensures everyone feels at home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Washer Dryer Apartments Atlanta",
      "seo_description": "Find in-unit washer dryer apartments in Atlanta at The Avenue. Experience convenience and luxury in downtown living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "luxury-walk-in-closets-downtown-atlanta-avenue",
      "search_query": "luxury walk-in closets downtown atlanta",
      "category": "Amenity",
      "h1_title": "Luxury Walk-In Closets in Downtown Atlanta",
      "h2_subtitle": "Discover spacious luxury walk-in closets at The Avenue, nestled in the heart of Downtown Atlanta. Enjoy sophisticated urban living.",
      "page_copy": "Transform your living experience with The Avenue’s luxury walk-in closets, perfectly positioned in the vibrant Downtown Atlanta. Our apartments redefine city living with expansive closets that set the standard for both style and functionality, accommodating all your wardrobe needs.\n\nAt The Avenue, elegance meets convenience with features like granite countertops and dedicated co-working spaces. Elevators and ceiling fans in bedrooms enhance your everyday comfort. Our community embraces diversity with Spanish-speaking staff, making it a welcoming environment for all.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Walk-In Closets in Downtown Atlanta",
      "seo_description": "Explore luxury walk-in closets in Downtown Atlanta at The Avenue. Indulge in sophisticated living with spacious amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-downtown-atlanta-avenue",
      "search_query": "one bedroom apartments downtown atlanta",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Downtown Atlanta",
      "h2_subtitle": "Discover stylish one bedroom apartments at The Avenue, ideally located in Downtown Atlanta. Enjoy modern urban living at its best.",
      "page_copy": "Experience the ultimate in urban living with The Avenue's one bedroom apartments, strategically located in Downtown Atlanta. Our community offers a harmonious blend of comfort and style, making it an ideal choice for those who want to enjoy city life.\n\nEach apartment at The Avenue features modern amenities such as granite countertops and elevator access. With ceiling fans in bedrooms and convenient co-working spaces, residents enjoy both comfort and functionality. Plus, Spanish-speaking staff ensure a welcoming atmosphere for everyone seeking luxury living in Atlanta.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Downtown Atlanta",
      "seo_description": "Find one bedroom apartments in Downtown Atlanta's The Avenue. Enjoy modern design and essential amenities in a prime city location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-fulton-county-ga-avenue",
      "search_query": "two bedroom apartments fulton county ga",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Fulton County, GA",
      "h2_subtitle": "Explore spacious two bedroom apartments at The Avenue, located in Fulton County, GA. Enjoy comfortable living in a vibrant community.",
      "page_copy": "Located in the lively Fulton County, GA, The Avenue offers spacious two bedroom apartments designed with modern living in mind. These apartments provide ample space and contemporary amenities, perfect for families or roommates seeking a comfortable living arrangement.\n\nResidents of The Avenue benefit from luxurious features such as granite countertops and convenient co-working spaces. With in-unit amenities like ceiling fans in bedrooms and elevator access, comfort is at the forefront. Our community also embraces diversity, offering Spanish language services to ensure everyone feels at home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Fulton County, GA",
      "seo_description": "Discover two bedroom apartments in Fulton County, GA at The Avenue. Enjoy modern amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "apartments-near-georgia-tech-atlanta-avenue",
      "search_query": "apartments near georgia institute of technology atlanta",
      "category": "School",
      "h1_title": "Apartments Near Georgia Tech in Atlanta",
      "h2_subtitle": "The Avenue offers stylish apartments just a short distance from Georgia Institute of Technology. Ideal for students and faculty alike.",
      "page_copy": "Experience unparalleled convenience at The Avenue, offering prime apartments near Georgia Institute of Technology in Atlanta. Our location is perfect for students, faculty, or anyone who wants easy access to the vibrant campus life and amenities.\n\nWith features like luxurious granite countertops and co-working spaces, The Avenue combines style with function. Residents enjoy modern comforts such as bedroom ceiling fans and express elevator access. Moreover, our community is welcoming, providing Spanish language services to ensure all feel at home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Georgia Tech in Atlanta",
      "seo_description": "Find apartments near Georgia Institute of Technology at The Avenue. Enjoy modern conveniences in a vibrant neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "apartments-close-to-emory-university-downtown-atlanta",
      "search_query": "apartments close to emory university downtown atlanta",
      "category": "School",
      "h1_title": "Apartments Close to Emory University Atlanta",
      "h2_subtitle": "Discover modern apartments close to Emory University in Downtown Atlanta. Perfect for students seeking convenient living.",
      "page_copy": "The Avenue provides contemporary apartment living close to Emory University in Downtown Atlanta, offering an ideal location for students and staff requiring proximity to the school. Experience the urban lifestyle with all the convenience of being near campus.\n\nOur apartments feature luxurious granite countertops and essential amenities such as co-working spaces and elevators. With ceiling fans in every bedroom and Spanish-speaking staff on-site, The Avenue ensures a comfortable and inclusive living environment. The vibrant Downtown Atlanta neighborhood adds to the appeal of this community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Emory University Atlanta",
      "seo_description": "Find modern apartments near Emory University in Downtown Atlanta at The Avenue. Enjoy luxury and convenience in the city.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "rentals-near-georgia-state-university-fulton-county",
      "search_query": "rentals near georgia state university fulton county",
      "category": "School",
      "h1_title": "Rentals Near Georgia State University",
      "h2_subtitle": "Discover rentals perfectly situated near Georgia State University in Fulton County. Ideal for students looking for convenience.",
      "page_copy": "The Avenue offers premium rentals near Georgia State University in the heart of Fulton County, providing unmatched convenience for students and faculty. Enjoy the dynamic atmosphere of city living with a short commute to campus.\n\nOur community is designed with comfort and accessibility in mind. Experience luxurious granite countertops and practical co-working spaces, all complemented by the modern convenience of elevators and ceiling fans in each bedroom. With bilingual staff on site, including Spanish-speaking services, The Avenue creates an inclusive and welcoming environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Georgia State University in Fulton",
      "seo_description": "Explore rentals near Georgia State University in Fulton County at The Avenue, featuring modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "apartments-near-t-deck-atlanta-ga-the-avenue",
      "search_query": "apartments near t deck atlanta ga",
      "category": "School",
      "h1_title": "Apartments Near T Deck Atlanta, GA",
      "h2_subtitle": "Discover apartments conveniently located near T Deck in Atlanta, GA. Ideal for those seeking convenient urban living.",
      "page_copy": "The Avenue offers stylish apartments near T Deck in Atlanta, GA, perfect for those who appreciate urban living and need easy access to parking options in the city center. Located in Downtown Atlanta, our community provides a convenient home base for navigating this bustling area.\n\nEnjoy modern living with luxurious features such as granite countertops in kitchens and baths, as well as co-working spaces ideal for remote work or study. Our building is equipped with elevators, and each bedroom includes a ceiling fan. Plus, with Spanish-speaking staff, The Avenue ensures a welcoming environment for all residents.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near T Deck Atlanta, GA",
      "seo_description": "Find modern apartments near T Deck in Atlanta, GA at The Avenue, offering comfort and convenience in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "apartments-close-to-scad-atlanta-30313",
      "search_query": "apartments close to scad atlanta 30313",
      "category": "School",
      "h1_title": "Apartments Near SCAD Atlanta 30313",
      "h2_subtitle": "Explore apartments conveniently located close to SCAD Atlanta in the 30313 area. Perfect for creative students and professionals.",
      "page_copy": "Located in the vibrant heart of Atlanta, The Avenue offers sophisticated apartments close to SCAD Atlanta, right within the 30313 area. Ideal for students and creative professionals, our community provides a comfortable and inspiring environment just a stone's throw from campus.\n\nAt The Avenue, residents enjoy premium amenities, including modern granite countertops, versatile co-working spaces, and efficient elevators. Each bedroom is outfitted with a ceiling fan, ensuring comfort throughout the year. With our bilingual staff, including Spanish language services, The Avenue fosters inclusivity and makes everyone feel at home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near SCAD Atlanta 30313",
      "seo_description": "Find stylish apartments near SCAD in Atlanta's 30313 at The Avenue, offering modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "apartments-near-grady-memorial-hospital-atlanta",
      "search_query": "apartments near grady memorial hospital atlanta",
      "category": "Hospital",
      "h1_title": "Apartments Near Grady Memorial Hospital",
      "h2_subtitle": "Find apartments conveniently located near Grady Memorial Hospital in Atlanta. Ideal for healthcare professionals and hospital visitors.",
      "page_copy": "Discover the comfort and convenience of The Avenue, offering contemporary apartments near Grady Memorial Hospital in Atlanta. Our location provides an excellent option for healthcare workers, students, and visitors who need proximity to the hospital.\n\nResidents at The Avenue benefit from thoughtfully designed living spaces equipped with granite countertops in both the kitchen and bathrooms, spacious co-working areas, and the convenience of elevator access. Bedrooms feature ceiling fans to enhance your living comfort. Our community welcomes diversity, offering services in Spanish and ensuring a warm, inviting atmosphere for everyone.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Grady Memorial Hospital Atlanta",
      "seo_description": "Explore comfortable apartments near Grady Memorial Hospital in Atlanta at The Avenue, featuring modern amenities and exceptional convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "apartments-close-to-emory-university-hospital-midtown",
      "search_query": "apartments close to emory university hospital midtown downtown atlanta",
      "category": "Hospital",
      "h1_title": "Apartments Near Emory University Hospital Midtown",
      "h2_subtitle": "Discover apartments conveniently located close to Emory University Hospital Midtown in Downtown Atlanta, perfect for students and professionals.",
      "page_copy": "The Avenue offers premium living spaces close to Emory University Hospital Midtown, situated in the dynamic Downtown Atlanta area. Our apartments provide the perfect setting for students, medical professionals, and anyone seeking proximity to this renowned institution.\n\nOur community features modern amenities including stylish granite countertops in kitchens and baths, and versatile co-working spaces ideal for both productivity and relaxation. Enjoy the ease of elevator service and the comfort of ceiling fans in each bedroom. Our welcoming environment is further enhanced by our bilingual staff, ensuring a friendly atmosphere for all residents.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Emory University Hospital Midtown",
      "seo_description": "Find modern apartments near Emory University Hospital Midtown in Downtown Atlanta at The Avenue, with exceptional amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "apartments-near-atlanta-botanical-garden-downtown",
      "search_query": "apartments near atlanta botanical garden downtown",
      "category": "Park",
      "h1_title": "Apartments Near Atlanta Botanical Garden",
      "h2_subtitle": "Find elegant apartments close to the Atlanta Botanical Garden, nestled in the vibrant Downtown Atlanta. Ideal for nature lovers and city dwellers alike.",
      "page_copy": "Experience urban living with a touch of nature at The Avenue, where you'll find beautifully designed apartments near the Atlanta Botanical Garden in Downtown Atlanta. Perfectly positioned for those who appreciate both city life and nature's tranquility, our location offers a unique living experience.\n\nResidents enjoy luxurious amenities such as granite countertops in the kitchen and bath, convenient co-working office spaces, and easy elevator access. Our bedrooms are finished with ceiling fans for added comfort. The Avenue also prides itself on being a diverse community, with Spanish-speaking staff ready to assist you, creating a welcoming atmosphere for everyone.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Atlanta Botanical Garden Downtown",
      "seo_description": "Explore stylish apartments near Atlanta Botanical Garden in Downtown Atlanta at The Avenue, offering modern amenities and a prime city location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "apartments-close-to-piedmont-park-ga",
      "search_query": "apartments close to piedmont park ga",
      "category": "Park",
      "h1_title": "Apartments Near Piedmont Park, GA",
      "h2_subtitle": "Explore chic apartments located near Piedmont Park, GA. Perfect for those seeking vibrant city living with park accessibility.",
      "page_copy": "The Avenue offers stylish living just a short distance from Piedmont Park, GA, ideally suited for individuals desiring both urban excitement and green recreation. Our community is nestled in Downtown Atlanta, ensuring residents have the best of both worlds at their doorstep.\n\nEnjoy a suite of appealing amenities that include modern granite countertops in kitchens and baths, comfortable co-working office spaces, and elevators for easy access. Every bedroom is equipped with ceiling fans, enhancing your living experience. Our property also proudly serves a diverse community with Spanish language assistance, fostering an inclusive and welcoming environment for all.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Piedmont Park, GA",
      "seo_description": "Discover chic apartments near Piedmont Park in GA at The Avenue, featuring stylish amenities and easy park access in Downtown Atlanta.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "apartments-near-centennial-olympic-park-fulton-county",
      "search_query": "apartments near centennial olympic park fulton county",
      "category": "Park",
      "h1_title": "Apartments Near Centennial Olympic Park",
      "h2_subtitle": "Discover vibrant apartments situated near Centennial Olympic Park in Fulton County, ideal for urban dwellers who love outdoor spaces.",
      "page_copy": "Welcome to The Avenue, where city living meets green spaces with our apartments located near Centennial Olympic Park in Fulton County. Perfectly placed in the heart of Downtown Atlanta, our community provides an effortless blend of excitement and relaxation.\n\nResidents enjoy top-tier amenities such as sleek granite countertops in kitchens and bathrooms, fully equipped co-working spaces, and reliable elevator access. With ceiling fans in every bedroom, comfort is always at hand. Additionally, we offer Spanish-speaking services to ensure an inclusive, community-oriented atmosphere for all our residents.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Centennial Olympic Park",
      "seo_description": "Discover apartments in Fulton County near Centennial Olympic Park at The Avenue, with modern amenities and a prime location in Downtown Atlanta.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "apartments-near-five-points-station-downtown-atlanta",
      "search_query": "apartments near Five Points station Downtown Atlanta",
      "category": "Transit",
      "h1_title": "Apartments Near Five Points Station",
      "h2_subtitle": "Explore convenient apartments near Five Points station, Downtown Atlanta, offering easy access to the city's bustling life and amenities.",
      "page_copy": "Discover the perfect blend of convenience and comfort at The Avenue, offering premier apartments near Five Points station in Downtown Atlanta. Ideal for commuters and urbanites, our location puts the city's pulse right at your doorstep.\n\nEnjoy a rich array of amenities including modern granite countertops in both kitchens and bathrooms and spacious co-working areas. Elevators provide ease of movement throughout the complex, and ceiling fans in each bedroom ensure comfortable living. Plus, with Spanish-speaking staff members, we cultivate a welcoming environment catering to diverse communities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Five Points Station Atlanta",
      "seo_description": "Find convenient apartments near Five Points station in Downtown Atlanta at The Avenue, offering easy city access and modern comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "apartments-close-to-arts-center-station-atlanta-ga",
      "search_query": "apartments close to Arts Center station Atlanta GA",
      "category": "Transit",
      "h1_title": "Apartments Near Arts Center Station Atlanta",
      "h2_subtitle": "Experience urban living near Arts Center station in Atlanta, GA. Perfect for arts enthusiasts and city dwellers seeking convenience.",
      "page_copy": "The Avenue provides an exceptional urban lifestyle just steps from Arts Center station in Atlanta, GA. Whether you're an arts lover or a city dweller, our prime location enhances your living experience with immediate access to Atlanta's vibrant cultural scene.\n\nOur community offers a range of desirable amenities, including elegant granite countertops in kitchens and bathrooms, dedicated co-working spaces, and the convenience of elevators. Each bedroom comes equipped with ceiling fans for year-round comfort. Additionally, our team is proud to offer services in Spanish, welcoming residents from diverse backgrounds into our inclusive community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Arts Center Station Atlanta",
      "seo_description": "Discover apartments near Arts Center station in Atlanta, GA at The Avenue, offering prime city access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "rentals-near-north-ave-station-fulton-county",
      "search_query": "rentals near North Ave station Fulton County",
      "category": "Transit",
      "h1_title": "Rentals Near North Ave Station",
      "h2_subtitle": "Find modern rentals conveniently located near North Ave station in Fulton County. Ideal for seamless city access and a vibrant lifestyle.",
      "page_copy": "Discover your ideal home at The Avenue, offering stylish rentals near North Ave station in Fulton County. This prime location is perfect for those seeking easy access to all Atlanta has to offer, providing both connectivity and community.\n\nThe Avenue features top-of-the-line amenities such as granite countertops in both kitchens and baths, co-working spaces designed for productivity, and easy elevator access. Each bedroom is equipped with ceiling fans to ensure a comfortable living environment. Our community values inclusivity, offering Spanish-speaking services to cater to diverse residents.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near North Ave Station Fulton",
      "seo_description": "Explore rentals near North Ave station, Fulton County at The Avenue with modern amenities and convenient access to Atlanta's attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "apartment-living-near-lindbergh-center-transit-midtown",
      "search_query": "apartment living near Lindbergh Center transit Midtown",
      "category": "Transit",
      "h1_title": "Apartment Living Near Lindbergh Center",
      "h2_subtitle": "Discover upscale apartment living near Lindbergh Center transit in Midtown. Embrace the convenience and vibrancy of Atlanta living.",
      "page_copy": "Experience unparalleled apartment living near Lindbergh Center transit in Midtown at The Avenue. Our community is strategically located to offer easy access to Atlanta’s dynamic urban lifestyle, combining transit convenience with modern comforts.\n\nThe Avenue features a host of luxurious amenities including stunning granite countertops in kitchens and baths, designed co-working spaces, and the comfort of ceiling fans in every bedroom. Enjoy the ease of elevators and services offered in Spanish, fostering an inclusive environment. Here, you can truly enjoy the best of city living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Living Near Lindbergh Center Midtown",
      "seo_description": "Enjoy upscale apartment living near Lindbergh Center transit in Midtown at The Avenue, featuring modern amenities and a vibrant location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167721",
      "source": "generator",
      "page_item_url": "apartments-by-midtown-station-30313",
      "search_query": "apartments by Midtown station 30313",
      "category": "Transit",
      "h1_title": "Apartments by Midtown Station 30313",
      "h2_subtitle": "Explore premier apartments by Midtown station in the 30313 area. Ideal for those seeking upscale living in a prime Atlanta location.",
      "page_copy": "Welcome to The Avenue, where city sophistication meets everyday comfort in our apartments by Midtown station, right in the 30313 area. Our strategic location places you at the center of Atlanta’s vibrant life, providing seamless connectivity to the city's amenities and attractions.\n\nThe Avenue boasts a range of feature-rich amenities, including chic granite countertops in all the kitchens and bathrooms, professional co-working spaces, and convenient elevator access. Each bedroom is equipped with modern ceiling fans, ensuring a comfortable atmosphere. Plus, our team is committed to providing service in both English and Spanish, welcoming a diverse community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Midtown Station 30313",
      "seo_description": "Discover modern apartments by Midtown station in the 30313 area at The Avenue, where city convenience meets premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InVkMzN5YzhFczRnajNrVlN3akFmZVE9PSIsInZhbHVlIjoiY0hISnRJODRUbStmWS8vRU1uWS9FQT09IiwibWFjIjoiNDFlNGQxN2NjMDNiMDgyNWYxZTc2ODEyYzBjMmI5NTI0ZTlkZWRlMWFlOGU1MzZiN2RmNzhlZGRiZWFjYjEyMSJ9"
    }
  ],
  "custom_apartmentsync_javascript_id": "eyJpdiI6InVkMzN5YzhFczRnajNrVlN3akFmZVE9PSIsInZhbHVlIjoiY0hISnRJODRUbStmWS8vRU1uWS9FQT09IiwibWFjIjoiNDFlNGQxN2NjMDNiMDgyNWYxZTc2ODEyYzBjMmI5NTI0ZTlkZWRlMWFlOGU1MzZiN2RmNzhlZGRiZWFjYjEyMSJ9"
};

export const generatedAt = '2026-09-11T19:13:53.028Z';
